<template>
  <div class="orderHomepage-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            订单信息
          </div>
          <div class="card-content" v-loading="loading">
            <div class="order-info">
              <span class="tit">订单号：</span>
              <span>{{orderInfo.ordernum}}</span>
              <span class="tit mf">生产单号：</span>
              <span v-if="orderInfo.produnum!==null&&orderInfo.produnum!==''&&orderInfo.produnum!==undefined" style="color:#409EFF;font-weight: 500">{{orderInfo.produnum}}</span>
              <span v-if="orderInfo.produnum===null||orderInfo.produnum===''||orderInfo.produnum===undefined" style="color:#999999;font-weight: 500">N/A</span>
              <span class="tit mf">订单类型：</span>
              <span v-if="orderInfo.type===0">正单</span>
              <span v-if="orderInfo.type===1">客改单</span>
              <span v-if="orderInfo.type===2">增补单</span>
              <span v-if="orderInfo.type===3">色板单</span>
              <span v-if="orderInfo.type===4">售后单</span>
              <span class="tit mf">订单性质：</span>
              <span v-if="orderInfo.nature===0">家装</span>
              <span v-if="orderInfo.nature===1">展厅</span>
              <span v-if="orderInfo.nature===2">工程</span>
              <span class="tit mf" v-if="orderInfo.type!==0">原正单号：</span>
              <span v-if="orderInfo.type!==0&&(orderInfo.oldorderid===null||orderInfo.oldorderid===''||orderInfo.oldorderid===undefined)">{{orderInfo.beforenum}} <el-tag v-if="orderInfo.beforeyear!==undefined&&orderInfo.beforeyear!==null&&orderInfo.beforeyear!==''" size="mini" type="warning" :disable-transitions="true">{{orderInfo.beforeyear}}年</el-tag></span>
              <span v-if="orderInfo.type!==0&&orderInfo.oldorderid!==null&&orderInfo.oldorderid!==''&&orderInfo.oldorderid!==undefined"><router-link :to="'/work/delorder/'+orderInfo.oldorderid" style="font-size: 13px;color:#409EFF;"><i class="el-icon-document"></i> {{orderInfo.beforenum}}</router-link> <el-tag size="mini" type="warning" :disable-transitions="true">{{orderInfo.beforeyear}}年</el-tag></span>
              <span v-if="orderInfo.type===3&&(orderInfo.oldorderid===null||orderInfo.oldorderid!==''||orderInfo.oldorderid!==undefined)">N/A</span>

            </div>
            <div class="order-info">
              <span class="tit">客户名称：</span>
              <span>{{orderInfo.custname}}</span>
              <span class="tit mf">客户电话：</span>
              <span>{{orderInfo.custtel}}</span>
              <span class="tit mf">详细地址：</span>
              <span>{{orderInfo.address}}</span>
            </div>
            <div class="order-info">
              <span class="tit">设计师：</span>
              <span>{{orderInfo.designer}}</span>
              <span class="tit mf">设计师电话：</span>
              <span>{{orderInfo.designerTel}}</span>
              <span class="tit mf">品牌：</span>
              <span>{{orderInfo.brand_name}}</span>
              <!-- <span class="tit mf">南北工艺：</span>
              <span>{{ orderInfo.craft == 1 ? '南' : (orderInfo.craft == 2 ? '北' : '-') }}</span> -->
              <span class="tit mf">色板来源：</span>
              <span>{{orderInfo.source}}</span>
<!--              <span v-if="orderInfo.source===0">厂部标准色板</span>-->
<!--              <span style="color:#F56C6C" v-if="orderInfo.source===1">客户提供色板</span>-->
<!--              <span style="color:#F56C6C" v-if="orderInfo.source===2">厂部定制色板</span>-->
            </div>
            <div class="order-info">
              <span class="tit" v-if="roleInfo.money===1">预估价格：</span>
              <span v-if="roleInfo.money===1&&orderInfo.estimated!==null&&orderInfo.estimated!==undefined&&orderInfo.estimated>0">{{orderInfo.estimated}} 元</span>
              <span v-if="roleInfo.money===1&&(orderInfo.estimated===null||orderInfo.estimated===undefined||orderInfo.estimated<=0)">未填写</span>
              <span :class="roleInfo.money===1?'tit mf':'tit'">下单日期：</span>
              <span>{{orderInfo.time}}</span>
              <span class="tit mf">期望交期：</span>
              <span>{{orderInfo.exptime}}</span>
              <span class="tit mf">计划交期：</span>
              <span>{{orderInfo.plannedAdd}}</span>
            </div>
            <div class="menu-list">
              <div class="menu-item" v-if="orderInfo.mark>8" @click="openChangeList">
                <div class="menu-item-img"><svg-icon icon-class="edit_change" /></div>
                <div class="menu-item-name" style="color:#67C23A">更改单</div>
                <div v-if="orderChangeCount>0" class="el-badge__content el-badge__content--success is-fixed">{{orderChangeCount}}</div>
              </div>
              <div v-if="orderInfo.mark>12" class="menu-item" @click="openDetails(orderInfo)">
                <div class="menu-item-img"><svg-icon icon-class="edit_pjprint" /></div>
                <div class="menu-item-name" style="color:#909399">打包详细</div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <!-- 厂部标准色板 -->
      <el-col v-if="swatchs.length > 0" class="card mt">
        <div class="card-body">
          <div class="card-title">
            <div class="card-title">厂部标准色板</div>
            <el-table
              stripe
              size="small"
              :data="swatchs"
              style="width: 100%"
            >
              <el-table-column
                label="色板"
                align="center"
                width="120">
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.img_url"
                    fit="cover"
                    style="width: 40px;height: 60px;"
                    :preview-src-list="[scope.row.img_url]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column prop="code" label="色板编号" min-width="140"></el-table-column>
              <el-table-column prop="name" label="名称" min-width="140"></el-table-column>
              <el-table-column prop="brand_name" label="品牌" min-width="100"></el-table-column>
              <el-table-column prop="series_name" label="系列" min-width="100"></el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
      <!-- 客供物料表格strat-->
      <el-col class="card mt">
        <div class="card-body">
          <div class="card-title">
            <div class="card-title">
              客供物料
              <el-button style="float: right" @click="addOcm()" size="small" icon="el-icon-plus">添加客供物料</el-button>
            </div>
            <el-table
              stripe
              size="small"
              :data="ocms"
              style="width: 100%">
              <el-table-column
                prop="cmname"
                label="物料名称"
                fixed
                width="140"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.cmname===''?'N/A':scope.row.cmname}}
                </template>
              </el-table-column>
              <el-table-column
                prop="explain"
                label="物料说明"
                min-width="160"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.explain===''?'N/A':scope.row.explain}}
                </template>
              </el-table-column>
              <el-table-column
                label="退还类型"
                align="center"
                width="120"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.cmtype===0?'无需退还':'需要退还'}}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="物流单号"
                width="140"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.transpnum===''?'N/A':scope.row.transpnum}}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="物流名称"
                width="140"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.transpName===''?'N/A':scope.row.transpName}}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="发货时间"
                width="140"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.hairTime===''?'N/A':scope.row.hairTime}}
                </template>
              </el-table-column>
              <el-table-column
                label="状态"
                width="110"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.hairTime===''" type="danger">未发货</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.hairTime!==''&&scope.row.serviceTime===''" class="tcf-tag-4">客服待收货</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.serviceTime!==''&&scope.row.pmcTime===''" class="tcf-tag-6">PMC待收货</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.pmcTime!==''&&scope.row.workshopTime===''" class="tcf-tag-7">车间待收货</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.cmtype===1&&scope.row.workshopTime!==''&&scope.row.returnWorkshopTime===''" class="tcf-tag-2">车间待退货</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.cmtype===0&&scope.row.workshopTime!==''&&scope.row.returnWorkshopTime===''" class="tcf-tag-2">车间已接收</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.returnWorkshopTime!==''&&scope.row.returnPmcTime===''" type="warning">PMC待退货</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.returnPmcTime!==''&&scope.row.returnServiceTime===''" class="tcf-tag-10">客服待退货</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.returnServiceTime!==''&&scope.row.returnHairTime===''" class="tcf-tag-10">客户待收货</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.returnHairTime!==''">已退还</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200" fixed="right" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button size="mini" v-if="scope.row.hairTime===''" @click="shipments(scope.row)"><i class="el-icon-truck"></i> 待发货</el-button>
                  <el-button size="mini" v-if="scope.row.hairTime===''" @click="daleteOmc(scope.row)"><i class="el-icon-delete"></i> 删除</el-button>
                  <el-button size="mini" v-if="scope.row.hairTime!==''&&scope.row.returnServiceTime==''" disabled><i class="el-icon-check"></i> 已发货</el-button>
                  <el-button size="mini" v-if="scope.row.hairTime!==''&&scope.row.returnServiceTime!==''&&scope.row.returnHairTime==''" @click="timeFormTrans(scope.row)"><i class="el-icon-time"></i> 待接收</el-button>
                  <el-button size="mini" v-if="scope.row.hairTime!==''&&scope.row.returnHairTime!==''" disabled><i class="el-icon-check"></i> 已接收</el-button>
                  <el-button size="mini" v-if="scope.row.hairTime!==''" disabled ><i class="el-icon-delete"></i> 删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
      <!--      客供物料发货表单 start-->
      <el-col class="card mt" v-if="(orderInfo.mark>3&&afterInfo!==null&&afterInfo!==undefined)||(orderInfo.mark>6&&splitInfo!==null&&splitInfo!==undefined)||(orderInfo.mark>8&&offerInfo!==null&&offerInfo!==undefined)">
        <div class="card-body" style="padding: 1.88rem 0.9rem;">
          <el-row>
            <el-col :span="8" style="padding:0 0.9rem" v-if="afterInfo!==null&&afterInfo!==undefined&&orderInfo.mark>3&&orderInfo.produnum.indexOf('SZ')>=0">
              <div class="card-title">
                售后信息
                <el-button @click="viewAfterDetail" style="float: right" type="text" size="mini">售后详情 <i class="el-icon-arrow-right"></i></el-button>
              </div>
              <div class="card-content">
                <div class="order-info info-ellipsis">
                  <span class="tit">处理人：</span>
                  <span>{{afterInfo.treat_user}}</span>
                </div>
                <div class="order-info info-ellipsis">
                  <span class="tit">处理时间：</span>
                  <span>{{afterInfo.treat_time}}</span>
                </div>
                <div class="order-info" style="padding-left: 60px">
                  <el-tooltip effect="dark" content="判定单" placement="top">
                    <el-image
                      style="width: 50px; height: 50px;position: absolute;top: 0;left: 0;border:1px dashed #f5f7fa"
                      :src="afterInfo.img_url"
                      :preview-src-list="[afterInfo.img_url]"
                      fit="cover"></el-image>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="返修单" placement="top">
                    <div class="file-item" @click="downFile(afterInfo.fileid)">
                      <i class="el-icon-document"></i>
                      <div class="file-name">
                        {{afterInfo.file_name}}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
                <div class="order-info" v-if="afterInfo.remark!==null&&afterInfo.remark!==''&&afterInfo.remark!==undefined">
                  <span class="tit">备注：</span>
                  <span>{{afterInfo.remark}}</span>
                </div>
              </div>
            </el-col>
            <el-col :span="8" style="padding:0 0.9rem;" v-if="splitInfo!==null&&splitInfo!==undefined&&orderInfo.mark>6">
              <div class="card-title">
                拆单信息
              </div>
              <div class="card-content">
                <div class="order-info info-ellipsis">
                  <span class="tit">拆单人员：</span>
                  <span>{{splitInfo.splitname}}</span>
                </div>
                <div class="order-info info-ellipsis">
                  <span class="tit">拆单时间：</span>
                  <span>{{splitInfo.splittime}}</span>
                </div>
                <div class="order-info info-ellipsis">
                  <span class="tit">拆单结果：</span>
                  <el-tooltip effect="dark" content="点击查看拆单详情" placement="top">
                    <span @click="getMaterialDetail" class="link" ><i class="el-icon-document"></i> {{splitInfo.splitfilename}}</span>
                  </el-tooltip>
                </div>
                <div class="order-info info-ellipsis">
                  <span class="tit">生产料单：</span>
                  <span @click="downFile(splitInfo.splitfileid)" class="link"><i class="el-icon-download"></i> 下载生产料单</span>
                </div>
              </div>
            </el-col>
            <el-col :span="8" style="padding:0 0.9rem" v-if="offerInfo!==null&&offerInfo!==undefined&&orderInfo.mark>8&&roleInfo.money===1">
              <div class="card-title">
                报价信息
                <el-button @click="viewOfferDetail" style="float: right" type="text" size="mini">报价详情 <i class="el-icon-arrow-right"></i></el-button>
              </div>
              <div class="card-content">
                <div class="order-info">
                  <span class="tit">总货款：</span>
                  <span class="price">{{offerInfo.amount}}</span>
                  <s style="font-size: 13px;color:#999;margin-left: 10px" v-if="offerInfo.amount!==offerInfo.totalprice">{{offerInfo.totalprice}}</s>
                  <el-tag type="danger" size="mini" style="margin-left: 10px" v-if="offerInfo.discount>0">{{offerInfo.discount}} 折</el-tag>
                </div>
                <div class="order-info">
                  <span class="tit">已收款：</span>
                  <span class="price">{{offerInfo.paidfor}}</span>
                  <span class="tit mf">余款：</span>
                  <span class="price">{{offerInfo.balance}}</span>
                  <el-tag size="mini" style="margin-left: 10px" v-if="offerInfo.balance<=0">已结清</el-tag>
                </div>
                <div class="order-info info-ellipsis">
                  <span class="tit">报价单：</span>
                  <el-tooltip effect="dark" :content="offerInfo.file_name" placement="top">
                    <span @click="downFile(offerInfo.fileid)" class="link"><i class="el-icon-download"></i> {{offerInfo.file_name}}</span>
                  </el-tooltip>
                </div>
                <div class="order-info" v-if="offerInfo.remark!==null&&offerInfo.remark!==''&&offerInfo.remark!==undefined">
                  <span class="tit">备注：</span>
                  <span>{{offerInfo.remark}}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-dialog
        :title="ocmTitle"
        :visible.sync="ocmVisible"
        width="40%"
        :destroy-on-close="true"
        :lock-scroll="true"
        :append-to-body="true">
        <el-form ref="ocmForm" :model="ocmForm" label-position="right" label-width="90px" size="small" :rules="ocmFormRules">
          <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
            <i class="el-icon-info"></i> 温馨提示：物流信息添加后将无法编辑/删除，请确认信息无误后再提交
          </div>
          <el-form-item label="物流单号" prop="transpnum">
            <el-input  v-model="ocmForm.transpnum" maxlength="40" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="物流名称" prop="transpName">
            <el-input  v-model="ocmForm.transpName" maxlength="20" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="发货日期" prop="hairTime">
            <el-date-picker
              v-model="ocmForm.hairTime"
              type="date"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item style="text-align: right;">
            <el-button type="primary" :loading="dynamicloading" @click="ocmTrans()">立即提交</el-button>
            <el-button @click="ocmVisible=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
<!--      客供物料发货表单end-->

<!--      客供物料返还接收时间start-->
      <el-dialog
        :title="timeTitle"
        :visible.sync="timeVisible"
        width="40%"
        :destroy-on-close="true"
        :lock-scroll="true"
        :append-to-body="true">
        <el-form ref="timeForm" :model="timeForm" label-position="right" label-width="90px" size="small" :rules="timeFormRules">
          <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
            <i class="el-icon-info"></i> 温馨提示：信息添加后将无法编辑/删除，请确认信息无误后再提交
          </div>
          <el-form-item label="收货日期" prop="returnHairTime">
            <el-date-picker
              v-model="timeForm.returnHairTime"
              type="date"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item style="text-align: right;">
            <el-button type="primary" :loading="dynamicloading" @click="ClientReceive(7)">立即提交</el-button>
            <el-button @click="timeVisible=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
<!--      客供物料返还接收时间end-->

<!--      添加客供物料表单start-->
      <el-dialog
        :title="ocmTitle"
        :visible.sync="addOcmVisible"
        width="40%"
        :destroy-on-close="true"
        :lock-scroll="true"
        :append-to-body="true">
        <el-form ref="addOcmForm" :model="addOcmForm" label-position="right" label-width="90px" size="small" :rules="addOcmFormRules">
          <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
            <i class="el-icon-info"></i> 温馨提示：客供物料信息添加后将无法修改，请确认信息无误后再提交
          </div>
          <el-form-item label="物料名称" prop="cmname">
            <el-select
              v-model="addOcmForm.cmname"
              filterable
              allow-create
              default-first-option
              style="width: 100%"
              placeholder="请选择或自定义物料名称">
              <el-option
                v-for="item in clientmaterial"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物料说明" prop="explain">
            <el-input  v-model="addOcmForm.explain" maxlength="50" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="退货类型" prop="cmtype">
            <el-radio v-model="addOcmForm.cmtype" label="0">无需退货</el-radio>
            <el-radio v-model="addOcmForm.cmtype" label="1">需要退货</el-radio>
          </el-form-item>
          <el-form-item style="text-align: right;">
            <el-button type="primary" :loading="dynamicloading" @click="ClientOcm()">立即提交</el-button>
            <el-button @click="addOcmVisible=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
<!--      添加客供物料表单 end-->
      <el-col class="card mt">
        <div class="card-body">
          <div class="card-title">
            订单跟踪
            <el-button style="float: right" @click="addDynamic(null)" size="small" icon="el-icon-plus">添加动态</el-button>
          </div>
          <div class="card-content" v-loading="trackLoading">
            <el-row>
              <el-col :span="7">
                <el-timeline style="padding: 10px" class="order-track">
                  <el-timeline-item timestamp="" v-if="orderInfo.mark>0&&orderInfo.mark<100">
                    <div v-if="orderInfo.mark===1">未提交</div>
                    <div v-if="orderInfo.mark===2">待接单</div>
                    <div v-if="orderInfo.mark===3">售后待处理</div>
                    <div v-if="orderInfo.mark===4">技术评估</div>
                    <div v-if="orderInfo.mark===5">拆单分配</div>
                    <div v-if="orderInfo.mark===6">待拆单</div>
                    <!-- <div v-if="orderInfo.mark===6&&(splitInfo.splittime===null||splitInfo.splittime===''||splitInfo.splittime===undefined)">
                      <span v-if="orderInfo.splitStatus == 0">拆单-未开始</span>
                      <span v-if="orderInfo.splitStatus == 1">拆单-进行中</span>
                      <span v-if="orderInfo.splitStatus == 2">拆单-已暂停</span>
                      <span v-if="orderInfo.splitStatus == 3">拆单-待拆单员确认</span>
                      <span v-if="orderInfo.splitStatus == 4">拆单-已完成</span>
                    </div> -->
                    <div v-if="orderInfo.mark===7">订单确认</div>
                    <div v-if="orderInfo.mark===8">待报价</div>
                    <div v-if="orderInfo.mark===9&&isokyfk!==1">预付款</div>
                    <div v-if="orderInfo.mark===9&&isokyfk===1">财务确认</div>
                    <div v-if="orderInfo.mark===10">订单生产中</div>
                    <div v-if="orderInfo.mark===11">订单生产中</div>
                    <div v-if="orderInfo.mark===12">订单生产中</div>
                    <div v-if="orderInfo.mark===13">订单生产中</div>
                    <div style="margin-top: 10px">
                      <el-button size="small" v-if="orderInfo.mark===1&&roleInfo.ddlr===1" @click="edit" type="primary">编辑提交</el-button>
                      <el-button size="small" v-if="orderInfo.mark===7&&roleInfo.ddqr===1" @click="ddqrBtn" type="primary">立即确认</el-button>
                      <el-button size="small" v-if="orderInfo.mark===9&&roleInfo.yfk===1&&isokyfk!==1" @click="yfkBtn" type="primary">立即预付</el-button>
                      <!-- <el-button v-if="orderInfo.mark===6&&orderInfo.splitStatus == 2" size="small" type="primary" @click="sqjxCdBtn">申请继续拆单</el-button> -->
                    </div>
                  </el-timeline-item>
                  <el-timeline-item
                    v-for="(t, index) in trackActivities"
                    :key="index"
                    type="primary"
                    size="large"
                    :timestamp="t.time">
                    {{t.name}}
                    <div v-if="t.username!==null&&t.username!==''&&t.username!==undefined" style="margin-top: 6px;font-size: 12px;">{{t.username}} <el-tag v-if="t.position!==null&&t.position!==''&&t.position!==undefined" size="mini" :type="t.color===0?'':t.color===1?'success':t.color===2?'danger':t.color===3?'warning':''" style="margin-left: 6px">{{t.position}}</el-tag></div>
                    <div v-if="t.remark!==null&&t.remark!==''&&t.remark!==undefined" style="margin-top: 6px;font-size: 12px;color:#999">{{t.remark}}</div>
                  </el-timeline-item>
                </el-timeline>
              </el-col>
              <el-col :span="17">
                <div class="order-dynamic-not" v-if="total===0&&trackLoading===false">
                  暂无订单动态数据
                </div>
                <div class="order-dynamic-item" v-for="d in orderDynamic">
                  <div class="photo">
                    <el-avatar shape="square" :size="50" :src="d.user_avatar"></el-avatar>
                  </div>
                  <div class="info">
                    <div class="username"><span>{{d.all_name}}</span><el-tag v-if="d.position_name!==undefined&&d.position_name!==null&&d.position_name!==''" :type="d.color===0?'':d.color===1?'success':d.color===2?'warning':''"  size="mini">{{d.position_name}}</el-tag></div>
                    <div class="time">
<!--                      <el-button v-if="d.user_id===user.userid && orderInfo.mark!==100 && d.user_type===0" style="margin-right: 10px;" size="mini" type="text" @click="addDynamic(d)">编辑</el-button>-->
<!--                      <el-button v-if="d.user_id===user.userid && orderInfo.mark!==100 && d.user_type===0" style="margin-right: 20px;" size="mini" type="text" @click="deleteDynamic(d)">删除</el-button>-->
                      <i class="el-icon-time"/>
                      {{d.time}}
                    </div>
                    <div class="content">
                      <el-tag :disable-transitions="true" v-if="d.content_type===1" effect="dark" style="margin-right: 6px" size="mini" type="danger">接单驳回</el-tag>
                      <el-tag :disable-transitions="true" v-if="d.content_type===2" effect="dark" style="margin-right: 6px" size="mini" type="danger">售后驳回</el-tag>
                      <el-tag :disable-transitions="true" v-if="d.content_type===3" effect="dark" style="margin-right: 6px" size="mini" type="danger">技术评估驳回</el-tag>
                      <el-tag :disable-transitions="true" v-if="d.content_type===4" effect="dark" style="margin-right: 6px" size="mini" type="danger">订单确认驳回</el-tag>
                      <el-tag :disable-transitions="true" v-if="d.content_type===5" effect="dark" style="margin-right: 6px" size="mini" type="danger">报价驳回</el-tag>
                      <el-tag :disable-transitions="true" v-if="d.content_type===6" effect="dark" style="margin-right: 6px" size="mini" type="danger">预付款驳回</el-tag>
                      <el-tag :disable-transitions="true" v-if="d.content_type===7" effect="dark" style="margin-right: 6px" size="mini" type="danger">工厂接单驳回</el-tag>
                      <el-tag :disable-transitions="true" v-if="d.content_type===8" effect="dark" style="margin-right: 6px" size="mini" type="danger">审单驳回</el-tag>
                      <el-tag :disable-transitions="true" v-if="d.content_type===99" effect="dark" style="margin-right: 6px" size="mini" type="danger">订单跳过预付款</el-tag>
                      <!-- <el-tag v-if="d.content_type===100" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="primary">开始拆单</el-tag>
                      <el-tag v-if="d.content_type===101" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="warning">暂停拆单</el-tag>
                      <el-tag v-if="d.content_type===102" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="primary">申请继续拆单</el-tag>
                      <el-tag v-if="d.content_type===103" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="warning">申请拆单调整</el-tag>
                      <el-tag v-if="d.content_type===104" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="primary">继续开始拆单</el-tag>
                      <el-tag v-if="d.content_type===105" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="primary">系统自动安排开始拆单</el-tag> -->
                      {{d.content}}
                    </div>
                    <div class="files">
                      <div class="file-item" v-for="f in d.fileList" @click="downFile(f.fileid)">
                        <i class="el-icon-document"></i>
                        <div class="file-name">
                          {{f.file_name}}.{{f.file_type}}
                        </div>
                      </div>
                    </div>
                    <div class="imgs">
                      <el-image
                        v-for="img in d.imgList"
                        fit="cover"
                        class="dynamic-img"
                        :src="img"
                        :preview-src-list="d.imgList">
                      </el-image>
                    </div>
                  </div>
                </div>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dynamicForm.title"
      :visible.sync="dynamicVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="dynamicForm" :model="dynamicForm" label-position="right" label-width="90px" size="small">
        <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info"></i> 温馨提示：订单动态添加后将无法编辑/删除，请确认信息无误后再提交
        </div>
        <el-form-item label="动态内容" prop="content">
          <el-input type="textarea" v-model="dynamicForm.content" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile :key="dynamicForm.key" v-model="dynamicForm.files" :old="dynamicForm.oldFiles"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg :key="dynamicForm.key" v-model="dynamicForm.imgids" :size="'sm'" :old="dynamicForm.oldImages"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="dynamicloading" @click="SubDynamic('dynamicForm')">立即提交</el-button>
          <el-button @click="dynamicVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="materialTitle"
      :visible.sync="materialVisible"
      width="80%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :before-close="closeMaterial"
      :append-to-body="true">
      <div style="height: 490px;width: 100%" v-loading="materialloading">
      <pl-table
        height="490px"
        :datas="materialTableData"
        :data="materialTableData"
        border
        size="small"
        use-virtual
        :pagination-show="false"
        :row-height="45">
        <pl-table-column prop="xuhao" label="序号" width="80" show-overflow-tooltip fixed></pl-table-column>
        <pl-table-column prop="area" label="区域" width="120" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="type" label="分类" width="80" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="name" label="名称" width="160" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="material" label="基材" width="80" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="high" label="高/长" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="width" label="宽" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="lwidth" label="L宽" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="ply" label="厚" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="num" label="数量" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="val" label="数值" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="unit" label="单位" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="color" label="颜色" width="140" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></pl-table-column>
      </pl-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="materialTableData=[],materialVisible=false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="afterTitle"
      :visible.sync="afterIVisible"
      width="762px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="fullscreenAfterLoading">
        <tr>
          <th>订单号</th>
          <td>{{afterinfoData.order.ordernum}}</td>
          <th>原正单号</th>
          <td>{{afterinfoData.order.beforenum}}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{afterinfoData.order.all_name}}</td>
          <th>生产车间</th>
          <td>{{afterinfoData.order.product_factory}}</td>
        </tr>
        <tr>
          <th>客诉时间</th>
          <td colspan="3">{{afterinfoData.order.time}}</td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="3">{{afterinfoData.order.address}}</td>
        </tr>
        <tr>
          <th>投诉内容</th>
          <td colspan="3">{{afterinfoData.afterSale.content}}</td>
        </tr>
        <tr>
          <th>返修单</th>
          <td colspan="3">
            <span @click="downFile(afterinfoData.afterSale.reworkid)" class="tcf-link"><i class="el-icon-download"></i> {{afterinfoData.afterSale.reworkname}}</span>
          </td>
        </tr>
        <tr>
          <th>判定单</th>
          <td colspan="3">
            <el-image
              style="width: 60px; height: 60px;"
              fit="cover"
              :preview-src-list="[afterinfoData.afterSale.decision_url]"
              :src="afterinfoData.afterSale.decision_url">
            </el-image>
          </td>
        </tr>
        <tr>
          <th style="width:80px">责任部门<br>售后原因</th>
          <td colspan="3">
            <el-table
              size="mini"
              :data="afterinfoData.deptRson"
              style="width: 100%">
              <el-table-column
                prop="deptname"
                label="责任部门"
                align="center"
                width="100"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="rsonname"
                label="售后原因"
                align="center"
                width="130"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="num"
                label="不良数量"
                align="center"
                width="100">
              </el-table-column>
              <el-table-column
                prop="remark"
                align="center"
                label="备注"
                show-overflow-tooltip>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr>
          <th>责任车间</th>
          <td>{{afterinfoData.factory}}</td>
          <th>售后赔款</th>
          <td>{{afterinfoData.afterSale.amount}}&nbsp;元</td>
        </tr>
        <tr>
          <th>售后备注</th>
          <td colspan="3">{{afterinfoData.afterSale.remark}}</td>
        </tr>
        <tr>
          <th>处理人</th>
          <td>{{afterinfoData.afterSale.username}}</td>
          <th>处理时间</th>
          <td>{{afterinfoData.afterSale.opertime}}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="afterIVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="offerInfo!==null&&offerInfo!==undefined"
      :title="offerTitle"
      :visible.sync="offerVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div style="font-size: 13px;color:#606266;padding: 0 20px" v-loading="fullscreenOfferLoading">
        <div>
          <span style="color:#99a9bf">报价员：</span>
          <span>{{offerInfo.offername}}</span>
          <span style="color:#99a9bf;margin-left: 20px">报价时间：</span>
          <span>{{offerInfo.time}}</span>
        </div>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">报价单：</span>
          <span @click="downFile(offerInfo.fileid)" class="tcf-link"><i class="el-icon-download"></i> {{offerInfo.file_name}}</span>
        </div>
        <el-card shadow="hover" style="margin-top: 15px">
          <div>
            <span style="color:#99a9bf">墙板：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{offerInfo.wall}}</span>元
            <span style="color:#99a9bf;margin-left: 20px">柜体：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{offerInfo.cabinet}}</span>元
            <span style="color:#99a9bf;margin-left: 20px">门类：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{offerInfo.door}}</span>元
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">铝材：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.aluminum }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">配件：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{offerInfo.access}}</span>元
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">加价：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{offerInfo.raise}}</span>元
            <span style="color:#99a9bf;margin-left: 20px">优惠：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{offerInfo.best}}</span>元
            <span style="color:#99a9bf;margin-left: 20px">折扣：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{offerInfo.discount}}</span>折
          </div>
        </el-card>
        <el-card v-if="offerAccountReceipt.length>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">折扣/优惠</span>
          <el-table
            :data="offerAccountReceipt"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              show-overflow-tooltip
              label="折扣/优惠名称"
              min-width="120"
            />
            <el-table-column
              width="120"
              align="right"
              show-overflow-tooltip
              label="优惠金额"
            >
              <template slot-scope="scope">
                <span style="color:#F56C6C;margin-right: 6px">{{ scope.row.money }}</span>元
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card shadow="hover" style="margin-top: 15px" v-if="offerInfo.other>0">
          <span style="color:#99a9bf">其他费用：</span>
          <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{offerInfo.other}}</span>元
          <el-table
            :data="offerOther"
            size="mini"
            :show-header="false"
            style="width: 100%">
            <el-table-column
              prop="name"
              show-overflow-tooltip
              label="费用名称"
              min-width="120">
              <template slot-scope="scope">
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.type===1" type="warning">木架</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.type===2" type="success">调色</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.type===3" type="info">水性漆</el-tag>
                <span :style="scope.row.type===1||scope.row.type===2||scope.row.type===3?'margin-left: 6px':''">{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              align="right"
              show-overflow-tooltip
              label="金额">
              <template slot-scope="scope">
                <span style="color:#F56C6C;margin-right: 6px">{{scope.row.amount}}</span>元
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card v-if="offerChanges.length>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">更改单费用：</span>
          <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.changes }}</span>元
          <span v-if="offerInfo.refund>0">，退款<span style="color:#F56C6C;font-size: 14px;margin-right: 6px;margin-left: 6px">{{ offerInfo.refund }}</span>元</span>
          <el-table
            :data="offerChanges"
            size="mini"
            :show-header="false"
            style="width: 100%">
            <el-table-column
              prop="num"
              label="更改单号"
              width="200"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===0" type="danger">设计变更</el-tag>
                <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===1" class="tcf-tag-4">材质变更</el-tag>
                <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===2" class="tcf-tag-6">暂停生产</el-tag>
                <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===3" class="tcf-tag-7">取消订单</el-tag>
                <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===4" class="tcf-tag-2">颜色变更</el-tag>
                <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===5" type="warning">通知单</el-tag>
                <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===6" class="tcf-tag-10">其他</el-tag>
                {{scope.row.num}}
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="变更内容"
              min-width="200"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              label="更改费用"
              width="100"
              fixed="right"
              align="right"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <span style="color:#f56c6c">{{scope.row.amount}}</span>元
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="100"
              fixed="right"
              align="right"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button type="text" @click="viewOrderChange(scope.row)" icon="el-icon-search" size="mini">详细</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">总报价：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerInfo.amount}}</span>元
          <s v-if="offerInfo.amount!==offerInfo.totalprice" style="margin-left: 10px;color:#999;">{{offerInfo.totalprice}}</s>
          <span style="margin-left: 20px">（大写：{{UpperAmount}}）</span>
        </div>
        <div style="margin-top: 15px" v-if="offerInfo.factorycom>0||offerInfo.designcom>0">
          <span style="color:#99a9bf">设计承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerInfo.designcom}}</span>元
          <span style="color:#99a9bf;margin-left: 20px">工厂承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerInfo.factorycom}}</span>元
          <span style="color:#99a9bf;margin-left: 20px">客户承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerInfo.clientcom}}</span>元
        </div>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">已收款：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerInfo.paidfor}}</span>元
          <span style="color:#99a9bf;margin-left: 20px">余款：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerInfo.balance}}</span>元
          <el-tag size="mini" style="margin-left: 10px" v-if="offerInfo.balance<=0">已结清</el-tag>
        </div>
        <div style="margin-top: 15px" v-if="offerImgs!==null&&offerImgs!==undefined&&offerImgs.length>0">
          <span style="color:#99a9bf">领导凭证：</span>
          <el-image v-for="img in offerImgs"
            style="width: 50px; height: 50px;margin-right: 10px"
            :src="img"
            :preview-src-list="offerImgs"
            fit="cover"></el-image>
        </div>
        <div style="margin-top: 15px" v-if="offerInfo.remark!==null&&offerInfo.remark!==''&&offerInfo.remark!==undefined">
          <span style="color:#99a9bf">备注：</span>
          <span>{{offerInfo.remark}}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="offerVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="订单确认"
      :visible.sync="ddqrVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="ddqrForm" :model="ddqrForm" :rules="ddqrRules"  label-position="right" label-width="90px" size="small">
        <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info"></i> 温馨提示：订单进入生产环节，为避免改单费用，请您仔细核查确认
        </div>
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="ddqrForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="确认备注" prop="content">
          <el-input type="textarea" v-model="ddqrForm.content" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="ddqrForm.files"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="ddqrForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" :loading="ddqrloading" @click="subEditDdqr('ddqrForm')">立即确认</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="ddqrloading" @click="turnDdqr('ddqrForm')">驳回</el-button>
          <el-button @click="ddqrVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="订单预付款"
      v-if="orderInfo.mark>8"
      :visible.sync="yfkVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="yfkForm" :model="yfkForm" :rules="yfkRules" v-loading="yfkofferinfoLoading" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="yfkForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="报价详情" prop="offerdetail">
          <el-card shadow="hover" style="font-size: 12px;color:#606266">
            <div>
              <span style="color:#99a9bf">总报价：</span>
              <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{yfkofferinfo.amount}}</span>元
              <s v-if="yfkofferinfo.amount!==yfkofferinfo.totalprice" style="margin-left: 10px;color:#999;">{{yfkofferinfo.totalprice}}</s>
              <el-tag type="danger" :disable-transitions="true" size="mini" style="margin-left: 10px" v-if="yfkofferinfo.discount>0">{{yfkofferinfo.discount}} 折</el-tag>
            </div>
            <div v-if="yfkofferinfo.factorycom>0||yfkofferinfo.designcom>0">
              <span style="color:#99a9bf">设计承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{yfkofferinfo.designcom}}</span>元
              <span style="color:#99a9bf;margin-left: 20px">工厂承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{yfkofferinfo.factorycom}}</span>元
              <span style="color:#99a9bf;margin-left: 20px">客户承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{yfkofferinfo.clientcom}}</span>元
            </div>
            <div>
              <span style="color:#99a9bf">预付款：</span>
              <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{yfkofferinfo.deposit}}</span>元
              <el-tag size="mini" :disable-transitions="true" v-if="yfkofferinfo.isall===0" style="margin-left: 10px">{{yfkofferinfo.deposit_per}}%</el-tag>
              <el-tag size="mini" :disable-transitions="true" v-if="yfkofferinfo.isall===1" style="margin-left: 10px" type="warning">≤{{yfkofferinfo.deposit_less}}取全款</el-tag>
            </div>
            <div v-if="yfkofferinfo.reportEndtime!==null&&yfkofferinfo.reportEndtime!==''&&yfkofferinfo.reportEndtime!==undefined">
              <span style="color:#99a9bf;font-size:12px;"><i class="el-icon-info"></i>
                当前折扣将在 <b v-if="yfkReportTime.day>0">{{yfkReportTime.day}}天</b> <b>{{yfkReportTime.hour}} : {{yfkReportTime.min}} : {{yfkReportTime.second}}</b>
                <span v-if="yfkofferinfo.reportEndDiscount>0">之后变为 <el-tag type="info" :disable-transitions="true" size="mini">{{yfkofferinfo.reportEndDiscount}} 折</el-tag></span>
                <span v-if="yfkofferinfo.reportEndDiscount<=0">之后失效</span>
              </span>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="收款账户" prop="aid" v-if="yfkofferinfo.deposit>0">
          <el-select v-model="yfkForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name">
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="打款日期" prop="receipttime" v-if="yfkofferinfo.deposit>0">
          <el-date-picker
            v-model="yfkForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="打款金额" prop="money" v-if="yfkofferinfo.deposit>0">
          <el-input v-model="yfkForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="card" v-if="yfkofferinfo.deposit>0">
          <el-input v-model="yfkForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="打款凭证" prop="imgids" v-if="yfkofferinfo.deposit>0">
          <MultiImg :limit="9" :key="yfkForm.key" :size="'sm'" v-model="yfkForm.imgids" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="yfkForm.remark" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" v-if="yfkofferinfo.deposit<=0" :loading="yfkloading" @click="subEditYfkTg('editForm')">立即确认</el-button>
          <el-button type="primary" icon="el-icon-check" :loading="yfkloading" v-if="yfkofferinfo.deposit>0" @click="subEditYfk('yfkForm')">立即预付</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="yfkloading" @click="turnYfk('yfkForm')">驳回</el-button>
          <el-button @click="yfkVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="编辑订单"
      :visible.sync="editVisible"
      width="45%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right" label-width="100px" size="small">
        <el-form-item label="订单类型" prop="type">
          <el-radio v-model="editForm.type" :label="0">正单</el-radio>
          <el-radio v-model="editForm.type" :label="1" @change="changeType">客改单</el-radio>
          <el-radio v-model="editForm.type" :label="2" @change="changeType">增补单</el-radio>
          <el-radio v-model="editForm.type" :label="3" @change="changeType">色板单</el-radio>
          <el-radio v-model="editForm.type" :label="4" @change="changeType">售后单</el-radio>
        </el-form-item>
        <el-form-item v-if="editForm.type!==0&&editForm.type!==3">
          <div style="font-size: 12px;color:#99a9bf">
            <i class="el-icon-info"></i> 补单提示：<span style="font-weight: 500">一个正单只可下三个补单，一个正单一天只可下一个补单</span>，同个正单第1个补单设计部24小时内处理，第二个补单72小时内处理，第3个补单1周内处理，给您带来不便敬请谅解！<span style="font-weight: 500">预估价格在五千元以上，订单类型请选择正单</span>
          </div>
        </el-form-item>
        <el-form-item label="原正单" prop="oldorderid" v-if="editForm.type!==0&&isManual===false">
          <OrderSelect v-model="editForm.oldorderid" :key="orderLoad" v-on:setOrder="setOrder" :oldorderid="editForm.oldorderid" :disabled="editForm.delid===null||editForm.delid===''" :delid="editForm.delid"></OrderSelect>
          <el-button type="text" @click="openManual" icon="el-icon-edit" v-if="editForm.delid!==null&&editForm.delid!==''">找不到原正单，点击这里手动填写</el-button>
        </el-form-item>
        <el-form-item label="原正单" v-if="isManual===true&&editForm.type!==0" prop="delid">
          <el-col :span="6" style="padding-right: 10px">
            <el-form-item prop="beforenum">
              <el-input v-model="editForm.beforenum" :disabled="editForm.delid===null||editForm.delid===''" placeholder="请输入原正单生产单号" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item prop="beforeyear">
              <el-date-picker
                v-model="editForm.beforeyear"
                :disabled="editForm.delid===null||editForm.delid===''"
                type="year"
                format="yyyy年"
                value-format="yyyy"
                :picker-options="pickerYear"
                placeholder="选择原正单年份">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-button type="text" @click="isManual=false" icon="el-icon-search" v-if="editForm.delid!==null&&editForm.delid!==''">点击这里搜索原正单</el-button>
        </el-form-item>
        <el-form-item label="客户名称" prop="custname">
          <el-input v-model="editForm.custname" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="客户电话" prop="custtel">
          <el-input v-model="editForm.custtel" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="editForm.address" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="期望交期" prop="exptime">
          <el-date-picker
            v-model="editForm.exptime"
            type="date"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            placeholder="选择日期">
          </el-date-picker>
          <span style="color:#99a9bf;margin-left: 10px;font-size: 12px;">至少10天以上</span>
        </el-form-item>
        <el-form-item label="品牌" prop="bid">
          <span style="color:#99a9bf;" v-if="editForm.delid===null||editForm.delid===''">请先选择经销商</span>
          <el-radio
            v-model="editForm.bid"
            v-if="editForm.delid!==null&&editForm.delid!==''"
            v-for="item in brandInfo"
            :label="item.bid">{{item.brandname}}</el-radio>
        </el-form-item>
        <el-form-item label="设计师姓名" prop="designer">
          <el-input v-model="editForm.designer" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="设计师电话" prop="designerTel">
          <el-input v-model="editForm.designerTel" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="色板来源" prop="source">
          <el-checkbox-group v-model="editForm.source" @change="changeradio">
            <el-checkbox :label="0">厂部标准色板</el-checkbox>
            <el-checkbox :label="1">客户提供色板</el-checkbox>
            <el-checkbox :label="2">厂部定制色板</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="editForm.source && editForm.source.indexOf(0) > -1" label="厂部标准色板" prop="sids">
          <span v-if="!editForm.bid" style="color:#99a9bf;">请先选择品牌</span>
          <el-select
            v-else
            style="width: 100%;"
            v-model="editForm.sids"
            multiple
            filterable
            placeholder="可输入编号/名称搜索">
            <el-option
              v-for="(item, index) in cbList"
              :key="index"
              :label="item.code + ' / ' + item.name + ' / ' + item.seriesname"
              :value="item.board_id">
            </el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="预估价格" prop="estimated">
          <el-input v-model="editForm.estimated" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width: 200px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>-->
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEditOrder('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="更改单列表"
      :visible.sync="orderChangeVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div style="height:40px">
        <span style="color:#99a9bf">共</span>
        <span style="color:#409EFF;font-weight: 500;margin: 0 3px">{{ orderChangeData.length }}</span>
        <span style="color:#99a9bf">项</span>
        <el-button size="small" icon="el-icon-plus" type="primary" @click="editOrderChange(null)" style="float: right;">添加更改单</el-button>
      </div>
      <el-table
        :data="orderChangeData"
        v-loading="orderChangeLoading"
        height="400"
        style="width: 100%;border:1px solid #EBEEF5;"
        size="small">
        <el-table-column
          prop="num"
          label="更改单号"
          width="140"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="变更类别"
          width="100"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.type===0">设计变更</span>
            <span v-if="scope.row.type===1">材质变更</span>
            <span v-if="scope.row.type===2">暂停生产</span>
            <span v-if="scope.row.type===3">取消订单</span>
            <span v-if="scope.row.type===4">颜色变更</span>
            <span v-if="scope.row.type===5">通知单</span>
            <span v-if="scope.row.type===6">其他</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          label="变更内容"
          min-width="200"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="申请人"
          width="120"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.initname}}
          </template>
        </el-table-column>
        <el-table-column
          label="申请时间"
          width="160"
          prop="time"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="状态"
          width="100"
          align="center"
          fixed="right"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="danger">客服驳回</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1" class="tcf-tag-4">客服确认</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2" class="tcf-tag-6">生产动态</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===3" class="tcf-tag-7">设计确认</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===4" class="tcf-tag-2">待报价</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===5" type="warning">待确认</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===6" class="tcf-tag-10">PMC确认</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===100">已完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-dropdown v-if="scope.row.mark>=0&&scope.row.mark<=1&&scope.row.dept===0" size="mini" @click="viewOrderChange(scope.row)" split-button icon="el-icon-edit">
              <i class="el-icon-search"></i> 查看
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="editOrderChange(scope.row)"><i class="el-icon-edit"></i> 编辑</el-dropdown-item>
                <el-dropdown-item @click.native="delOrderChange(scope.row.ocid)" style="color:#F56C6C"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button icon="el-icon-search" @click="viewOrderChange(scope.row)" size="mini" v-if="scope.row.mark>1||scope.row.dept!==0">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :title="editOrderChangeTitle"
      :visible.sync="editOrderChangeVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editOrderChangeForm" :model="editOrderChangeForm" :rules="editOrderChangeRules"  label-position="right" label-width="90px" size="small">
        <el-form-item label="订单号">
          <el-input v-model="orderInfo.ordernum" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="生产单号">
          <el-input v-model="orderInfo.produnum" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="orderInfo.address" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="变更类别" prop="type">
          <el-radio v-model="editOrderChangeForm.type" :label="0">设计变更</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="1">材质变更</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="2">暂停生产</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="3">取消订单</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="4">颜色变更</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="5">通知单</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="6">其他</el-radio>
        </el-form-item>
        <el-form-item label="变更内容" prop="content">
          <el-input type="textarea" v-model="editOrderChangeForm.content" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
        </el-form-item>
        <el-form-item label="备注说明">
          <el-input type="textarea" v-model="editOrderChangeForm.remark" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附属文件">
          <MultiFile v-model="editOrderChangeForm.files"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片">
          <span style="color:#99a9bf; font-size: 12px;">请上传色板照片</span>
          <MultiImg v-model="editOrderChangeForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editOrderChangeLoading" @click="subOrderChangeEdit">立即提交</el-button>
          <el-button @click="editOrderChangeVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="viewOrderChangeTitle"
      :visible.sync="viewOrderChangeVisible"
      width="1120px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row v-loading="viewOrderChangeLoading">
        <el-col :span="10">
          <table class="tcf-detail-table">
            <tr>
              <th>更改单号</th>
              <td>{{viewOrderChangeData.oc.num}}</td>
              <th>生产单号</th>
              <td>{{viewOrderChangeData.oc.produnum}}</td>
            </tr>
            <tr>
              <th>详细地址</th>
              <td colspan="3">{{viewOrderChangeData.oc.address}}</td>
            </tr>
            <tr>
              <th>变更类别</th>
              <td>
                <span v-if="viewOrderChangeData.oc.type===0">设计变更</span>
                <span v-if="viewOrderChangeData.oc.type===1">材质变更</span>
                <span v-if="viewOrderChangeData.oc.type===2">暂停生产</span>
                <span v-if="viewOrderChangeData.oc.type===3">取消订单</span>
                <span v-if="viewOrderChangeData.oc.type===4">颜色变更</span>
                <span v-if="viewOrderChangeData.oc.type===5">通知单</span>
                <span v-if="viewOrderChangeData.oc.type===6">其他</span>
              </td>
              <th>申请部门</th>
              <td>
                <span v-if="viewOrderChangeData.oc.dept===0">客户</span>
                <span v-if="viewOrderChangeData.oc.dept===1">拆单</span>
                <span v-if="viewOrderChangeData.oc.dept===2">方案</span>
                <span v-if="viewOrderChangeData.oc.dept===3">车间</span>
                <span v-if="viewOrderChangeData.oc.dept===4">采购</span>
                <span v-if="viewOrderChangeData.oc.dept===5">软件</span>
                <span v-if="viewOrderChangeData.oc.dept===6">其他</span>
                <span v-if="viewOrderChangeData.oc.dept===7">建模</span>
                <span v-if="viewOrderChangeData.oc.dept===8">研发</span>
              </td>
            </tr>
            <tr>
              <th>变更内容</th>
              <td colspan="3"><div class="pl">{{ viewOrderChangeData.oc.content }}</div></td>
            </tr>
            <tr>
              <th>拆单人员</th>
              <td>{{viewOrderChangeData.oc.splitname}}</td>
              <th>生产动态</th>
              <td style="font-weight: bold;color:#f56c6c">
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===0">PMC阶段</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===1">开料完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===2">组装完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===3">贴皮完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===4">白胚完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===5">做灰完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===6">底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===7">粗磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===8">二次底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===9">细磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===10">面漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===11">包装完工</span>
              </td>
            </tr>
            <tr>
              <th>变更原因</th>
              <td colspan="3">{{viewOrderChangeData.oc.rson}}</td>
            </tr>
            <tr>
              <th colspan="2" style="text-align: center">变更前内容</th>
              <th colspan="2" style="text-align: center">变更后内容</th>
            </tr>
            <tr>
              <td colspan="2">{{viewOrderChangeData.oc.beforetxt}}</td>
              <td colspan="2">{{viewOrderChangeData.oc.aftertxt}}</td>
            </tr>
            <tr v-if="roleInfo.money===1&&viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">
              <th>报价明细</th>
              <td colspan="3">{{viewOrderChangeData.oc.offerdetail}}</td>
            </tr>
            <tr v-if="viewOrderChangeData.oc.mark>4">
              <th v-if="roleInfo.money===1&&viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">报价费用</th>
              <td v-if="roleInfo.money===1&&viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4" style="font-weight: bold;color:#409EFF">{{viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.amount:''}}</td>
              <th>交期延长</th>
              <td :colspan="roleInfo.money===1&&viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4?1:3">{{viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.day+'天':''}}</td>
            </tr>
            <tr v-if="roleInfo.money===1&&viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">
              <th>费用承担</th>
              <td colspan="3">
                <span style="color:#99a9bf">设计承担:</span>
                <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 3px">{{ viewOrderChangeData.oc.designcom }}</span>元
                <span style="color:#99a9bf;margin-left: 8px">工厂承担:</span>
                <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 3px">{{ viewOrderChangeData.oc.factorycom }}</span>元
                <span style="color:#99a9bf;margin-left: 8px">客户承担:</span>
                <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 3px">{{ viewOrderChangeData.oc.clientcom }}</span>元
                <span style="color:#99a9bf;margin-left: 8px">退款金额:</span>
                <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 3px">{{ viewOrderChangeData.oc.refund }}</span>元
              </td>
            </tr>
          </table>
        </el-col>
        <el-col :span="5">
          <el-timeline>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>0?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>0?viewOrderChangeData.oc.time:''">
              提交
              <div v-if="viewOrderChangeData.oc.mark===0" style="margin-top: 10px">
                <el-button size="small" @click="editOrderChange(viewOrderChangeData.oc)" type="primary">重新编辑</el-button>
              </div>
              <div v-if="viewOrderChangeData.oc.mark>0" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.initname}}<el-tag size="mini" :type="viewOrderChangeData.oc.inittype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.initposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>1?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>1?viewOrderChangeData.oc.sercontime:''">
              客服确认
              <div v-if="viewOrderChangeData.oc.mark>1" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.servicename}}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.serviceposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>2?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>2?viewOrderChangeData.oc.pmctime:''">
              生产动态
              <div v-if="viewOrderChangeData.oc.mark>2" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.pmcuname}}<el-tag size="mini" type="warning" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcuposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>3?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>3?viewOrderChangeData.oc.assesstime:''">
              设计确认
              <div v-if="viewOrderChangeData.oc.mark>3" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.assessname}}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.assessposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=4||viewOrderChangeData.oc.offerid!==0"
              :type="viewOrderChangeData.oc.mark>4?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.offertime:''">
              更改单报价
              <div v-if="viewOrderChangeData.oc.mark>4" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.offername}}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.offerposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=5||viewOrderChangeData.oc.conid!==0"
              :type="viewOrderChangeData.oc.mark>5?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>5?viewOrderChangeData.oc.contime:''">
              客户确认
              <div v-if="viewOrderChangeData.oc.mark===5" style="margin-top: 10px">
                <el-button size="small" @click="orderChangConfirm(viewOrderChangeData.oc.ocid)" type="primary">立即确认</el-button>
              </div>
              <div v-if="viewOrderChangeData.oc.mark>5" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.conname}}<el-tag size="mini" :type="viewOrderChangeData.oc.contype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.conposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>6?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.pmccontime:''">
              PMC确认
              <div v-if="viewOrderChangeData.oc.mark>6" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.pmcconname}}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcconposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark===100?'primary':''">
              完成
            </el-timeline-item>
          </el-timeline>
        </el-col>
        <el-col :span="9" class="tcf-order-change-remark">
          <div class="title">
            <span>更改单备注</span>
            <el-button size="small" icon="el-icon-plus" @click="addOrderChangeRemark()">添加备注</el-button>
          </div>
          <div v-if="viewOrderChangeData.ocrlst.length===0" class="order-dynamic-not">
            暂无更改单备注数据
          </div>
          <div class="content-list">
            <div v-for="d in viewOrderChangeData.ocrlst" class="order-dynamic-item">
              <div class="photo">
                <el-avatar shape="square" :size="50" :src="d.photo"/>
              </div>
              <div class="info">
                <div class="username"><span>{{ d.username }}</span><el-tag v-if="d.posname!==null&&d.posname!==''&&d.posname!==undefined" :type="d.color===0?'':d.color===1?'success':d.color===2?'warning':''" size="mini">{{ d.posname }}</el-tag></div>
                <div class="time"><i class="el-icon-time" /> {{ d.time }}</div>
                <div class="content">
                  <el-tag v-if="d.ctype===1" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客服确认驳回</el-tag>
                  <el-tag v-if="d.ctype===2" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">生产动态驳回</el-tag>
                  <el-tag v-if="d.ctype===3" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">设计确认驳回</el-tag>
                  <el-tag v-if="d.ctype===4" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">报价驳回</el-tag>
                  <el-tag v-if="d.ctype===5" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客户确认驳回</el-tag>
                  <el-tag v-if="d.ctype===6" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">PMC确认驳回</el-tag>
                  {{ d.content }}
                </div>
                <div class="files">
                  <div v-for="f in d.filelst" class="file-item" @click="downFile(f.fileid,0)">
                    <i class="el-icon-document" />
                    <div class="file-name">{{ f.file_name }}.{{ f.file_type }}</div>
                  </div>
                </div>
                <div class="imgs">
                  <el-image
                    v-for="img in d.imglst"
                    fit="cover"
                    class="dynamic-img"
                    :src="img"
                    :preview-src-list="d.imglst"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      :title="dynamicForm.title"
      :visible.sync="orderchangeRemarkVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="orderchangeRemarkForm" :model="dynamicForm" label-position="right" label-width="90px" size="small">
        <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info"></i> 温馨提示：更改单备注添加后将无法编辑/删除，请确认信息无误后再提交
        </div>
        <el-form-item label="备注内容" prop="content">
          <el-input type="textarea" v-model="dynamicForm.content" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile :key="dynamicForm.key" v-model="dynamicForm.files" :old="dynamicForm.oldFiles"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg :key="dynamicForm.key" v-model="dynamicForm.imgids" :size="'sm'" :old="dynamicForm.oldImages"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="dynamicloading" @click="SubOrderChangeRemark('orderchangeRemarkForm')">立即提交</el-button>
          <el-button @click="orderchangeRemarkVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="客户确认-更改单"
      :visible.sync="orderChangeOperVisible"
      width="500px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="orderChangeOperForm" :model="orderChangeOperForm" :rules="orderChangeOperRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="备注内容" prop="remark">
          <el-input v-model="orderChangeOperForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" :loading="orderChangeOperloading" @click="subOrderChangeOperForm(1)">{{orderChangeOperForm.mark===2?'评估完成':'立即确认'}}</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="orderChangeOperloading" @click="subOrderChangeOperForm(0)">驳回</el-button>
          <el-button @click="orderChangeOperVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :title="packTitle"
      :visible.sync="packVisible"
      width="700px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form size="small" ref="packForm" :inline="true" :model="packForm" label-width="60px">
        <el-form-item label="标签号" prop="packnum">
          <el-input v-model="packForm.packnum" maxlength="14" style="width: 130px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="包号" prop="xuhao">
          <el-input type="number" v-model="packForm.xuhao" style="width: 130px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchPack" icon="el-icon-search">搜索</el-button>
          <el-button icon="el-icon-printer" :loading="exportMaterialLoading" plain @click="exportExcelMaterial">导出Excel</el-button>
        </el-form-item>
      </el-form>
      <div style="padding-bottom: 20px" v-loading="packloading">
        <el-table
          ref="packTable"
          :data="packTableData"
          :row-style="{cursor: 'pointer'}"
          @row-click="openPackDetails"
          class="tcf-expand"
          min-height="400"
          @selection-change="handleSelectionChange"
          size="small">
          <el-table-column
            type="selection"
            width="50">
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="tcf-panel">
                <p class="tcf-panel-header">
                  <span style="color:#99a9bf"><i class="el-icon-box"></i> 包装 {{props.row.packnum}} 部件详细</span>
                </p>
                <div class="tcf-panel-body">
                  <el-table
                    :data="props.row.materialdataList"
                    size="mini"
                    :show-header="false"
                    style="width: 100%">
                    <el-table-column prop="barCode" fixed label="条码" show-overflow-tooltip width="130"></el-table-column>
                    <el-table-column prop="xuhao" fixed label="序号" show-overflow-tooltip width="70"></el-table-column>
                    <el-table-column prop="area" label="区域" show-overflow-tooltip width="100"></el-table-column>
                    <el-table-column prop="type" label="分类" show-overflow-tooltip width="80"></el-table-column>
                    <el-table-column prop="name" label="名称" show-overflow-tooltip width="130"></el-table-column>
                    <el-table-column prop="material" label="基材" show-overflow-tooltip width="80"></el-table-column>
                    <el-table-column label="规格" show-overflow-tooltip width="140">
                      <template slot-scope="scope">
                        <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>
                        <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
                        <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>
                        <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
                        <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="color" label="颜色" show-overflow-tooltip min-width="130"></el-table-column>
                  </el-table>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="packnum" align="center" label="包标签号" show-overflow-tooltip width="130"></el-table-column>
          <el-table-column prop="xuhao" align="center" label="包号" show-overflow-tooltip width="90"></el-table-column>
          <el-table-column prop="iusername" align="center" label="入库人" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column prop="itime" align="center" label="入库时间" show-overflow-tooltip min-width="130"></el-table-column>
          <el-table-column prop="num" align="center" label="部件数量" show-overflow-tooltip width="90"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      title="申请继续拆单"
      :visible.sync="sqjxSplitVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="sqjxSplitForm" :model="sqjxSplitForm" :rules="sqjxSplitRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="sqjxSplitForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="备注内容" prop="content">
          <el-input v-model="sqjxSplitForm.content" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile key="sqjxSplitFile" v-model="sqjxSplitForm.files" />
        </el-form-item>
        <el-form-item label="凭证图片" prop="imgids">
          <MultiImg v-model="sqjxSplitForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="sqjxSplitLoading" @click="subSplitSqjx('sqjxSplitForm')">确认申请</el-button>
          <el-button @click="sqjxSplitVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerOrderDetail, DealerOrderEdit } from '@/api/dealer'
import {
  getErpDealerBrandList,
  getErpOrderOfferDetail,
  getDebitSMSCode,
  insteadSubsist,
  insteadSubsistDown,
  confirmOrder,
  getOrderTrack,
  getOrderDynamic,
  addOrderDynamic,
  getErpOrderMaterialDetail,
  getAfterSalePageInfo,
  getOrderQuoteDetail,
  digitUppercase,
  addOrEditCollectApplyConfirm,
  editOrderChange,
  getOrderChangeListByOrderid,
  delOrderChange,
  getOrderChangeDetail,
  addOrderChangeRemark,
  operOrderChange,
  selectClientOcm,
  upClientOcm,
  addClientOcm,
  deleteClientOmc,
  upReceiveTime,
  getClientMaterial,
  exportShippingList,
  getErpOrderPackList,
} from '@/api/erp'
import { getFileInfo, getGroupReport, getAccounts } from '@/api/pub'
import { getDealerTelList, deleteOrderDynamic } from '@/api/work'
import { getColorBoardList } from '@/api/about/swatch'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'
import { validatePhoneNumber } from '@/utils/validate'
import OrderSelect from '@/components/OrderSelect'

export default {
  name: 'DealerOrderHomepage',
  computed: {
    user: getUser,
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() < Date.now() + 9 * 24 * 60 * 60 * 1000
        }
      }
    },
    pickerYear() {
      return {
        disabledDate(time) {
          return time.getTime() >= Date.now()
        }
      }
    }
  },
  components: {
    OrderSelect,
    MultiFile,
    MultiImg
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    return {
      ocms: [],
      swatchs: [],
      ocmTitle: '',
      clientmaterial: [],
      addOcmVisible: false,
      addOcmFormRules: {
        cmname: [{ required: true, message: '请填写物料名称', trigger: 'blur' }],
        explain: [{ required: true, message: '请填写物料说明', trigger: 'blur' }]
      },
      addOcmForm: {
        orderid: '',
        cmname: '',
        explain: '',
        cmtype: '0'
      },
      ocmVisible: false,
      ocmForm: {
        cmid: '',
        personid: '',
        transpnum: '',
        transpName: '',
        hairTime: ''
      },
      ocmFormRules: {
        transpnum: [{ required: true, message: '请填写快递单号', trigger: 'blur' }],
        transpName: [{ required: true, message: '请填写物流名称', trigger: 'blur' }],
        hairTime: [{ required: true, message: '选择发货日期', trigger: 'blur' }]
      },
      timeTitle: '接收时间',
      timeVisible: false,
      cmid: '',
      timeForm: {
        returnHairTime: ''
      },
      timeFormRules: {
        returnHairTime: [{ required: true, message: '日期不能为空', trigger: 'blur' }],
      },
      orderChangeOperVisible: false,
      orderChangeOperloading: false,
      orderChangeOperForm: {
        ocid: 0,
        remark: ''
      },
      orderChangeOperRules: {
        remark: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }]
      },
      orderid: '',
      orderChangeCount: 0,
      orderChangeVisible: false,
      orderChangeLoading: false,
      orderChangeData: [],
      fullscreenLoading: false,
      loading: false,
      orderInfo: [],
      afterInfo: [],
      splitInfo: [],
      offerInfo: [],
      UpperAmount: '零元整',
      roleInfo: [],
      trackLoading: false,
      trackActivities: [],
      orderDynamic: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dynamicVisible: false,
      dynamicloading: false,
      dynamicForm: {
        dynamicId: 0,
        title: '添加订单动态',
        content: '',
        files: [],
        imgids: [],
        oldImages: [],
        oldFiles: [],
        key: ''
      },
      materialTableData: [],
      materialVisible: false,
      materialloading: false,
      materialTitle: '',
      afterIVisible: false,
      fullscreenAfterLoading: false,
      afterinfoData: {
        rson: '',
        factory: '',
        deptRson: [],
        order: {
          ordernum: null,
          beforenum: null,
          time: null,
          all_name: null,
          address: null,
          product_factory: null
        },
        afterSale: {
          decision_url: null,
          content: null,
          reworkname: null,
          reworkid: null,
          remark: null,
          amount: null,
          opertime: null,
          username: null
        }
      },
      isAfterinfo: false,
      afterTitle: '',
      offerTitle: '',
      offerVisible: false,
      isOfferInfo: false,
      offerImgs: [],
      offerOther: [],
      offerChanges: [],
      offerAccountReceipt: [],
      fullscreenOfferLoading: false,
      ddqrVisible: false,
      ddqrloading: false,
      ddqrForm: {
        orderid: '',
        ordername: '',
        content: '',
        files: [],
        imgids: []
      },
      ddqrRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }]
      },
      yfkVisible: false,
      yfkloading: false,
      yfkisDisabledCode: true,
      yfkisCodeLoading: false,
      yfkcodeBtn: '获取验证码',
      yfkcodeTimer: '',
      yfksounds: 60,
      yfkForm: {
        orderid: '',
        ordername: '',
        content: '',
        offername: '',
        offertime: '',
        offerfile: '',
        offerfileid: '',
        money: null,
        dedutel: '',
        msg_id: '',
        code: '',
        accid: null,
        deposit: 0,
        accamount: 0,
        card: '',
        imgids: [],
        receipttime: '',
        aid: '',
        remark: '',
        key: ''
      },
      yfkofferinfoLoading: false,
      yfkofferinfo: [],
      yfkReportTime: {
        curStartTime: '',
        day: 0,
        hour: '00',
        min: '00',
        second: '00'
      },
      yfkRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        remark: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }],
        money: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        dedutel: [{ required: true, message: '请选择扣款验证号码', trigger: 'change' }],
        code: [{ required: true, message: '请输入六位短信验证码', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        aid: [{ required: true, message: '请选择收款账户', trigger: 'change' }],
        card: [{ required: true, message: '请输入卡号', trigger: 'blur' }]
      },
      yfkDealerTelList: [],
      editloading: false,
      isManual: false,
      orderLoad: '',
      brandInfo: [],
      editForm: {
        delid: '',
        type: 0,
        oldorderid: '',
        beforenum: '',
        beforeyear: '',
        custname: '',
        custtel: '',
        address: '',
        exptime: '',
        designer: '',
        designerTel: '',
        estimated: null,
        bid: null,
        source: [],
        sids: []
      },
      editRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        type: [{ required: true, message: '请选择订单类型', trigger: 'change' }],
        oldorderid: [{ required: true, message: '请选择原正单', trigger: 'change' }],
        custname: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        custtel: [{ required: true, trigger: 'blur', validator: validatePhone }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        exptime: [{ required: true, message: '请选择期望交期', trigger: 'change' }],
        bid: [{ required: true, message: '请选择品牌', trigger: 'change' }],
        source: [{ required: true, message: '请选择色板来源', trigger: 'change' }],
        sids: [{ required: true, message: '请选择色板', trigger: 'change' }],
        designer: [{ required: true, message: '请输入设计师姓名', trigger: 'blur' }],
        designerTel: [{ required: true, trigger: 'blur', validator: validatePhone }],
        beforenum: [{ required: true, message: '请输入原正单号', trigger: 'blur' }],
        beforeyear: [{ required: true, message: '请选择原正单年份', trigger: 'change' }],
        imgids: [{ required: true, message: '请上传图片', trigger: 'change' }]
      },
      isHaveBrand: false,
      editVisible: false,
      isokyfk: 0,
      editOrderChangeTitle: '',
      editOrderChangeVisible: false,
      editOrderChangeLoading: false,
      editOrderChangeForm: {
        ocid: 0,
        orderid: '',
        type: 0,
        content: '',
        remark: '',
        imgids: [],
        files: []
      },
      editOrderChangeRules: {
        ispub: [{ required: true, message: '请选择是否公开', trigger: 'change' }],
        dept: [{ required: true, message: '请选择申请部门', trigger: 'change' }],
        type: [{ required: true, message: '请选择变更类别', trigger: 'change' }],
        content: [{ required: true, message: '请填写订单变更内容', trigger: 'blur' }]
      },
      viewOrderChangeTitle: '',
      viewOrderChangeVisible: false,
      viewOrderChangeLoading: false,
      viewOrderChangeData: {
        oc: [],
        ocrlst: []
      },
      orderchangeRemarkVisible: false,
      editocid: 0,

      exportMaterialLoading: false,
      multipleSelection: [],
      packTitle: '',
      packVisible: false,
      editLoading: false,
      packForm: {
        orderid: '',
        packnum: '',
        xuhao: ''
      },
      packTableData: [],
      packloading: false,

      cbList: [],
      cbLoading: false,

      sqjxSplitVisible: false,
      sqjxSplitLoading: false,
      sqjxSplitForm: {
        ordername: '',
        orderid: '',
        content: '',
        files: [],
        imgids: []
      },
      sqjxSplitRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传图片', trigger: 'change' }],
      },
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.orderid = this.$route.params && this.$route.params.id
    this.getOrder()
    this.getClientocm()
    getGroupReport().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
    getClientMaterial().then(response => {
      this.clientmaterial = response.data
    }).catch(() => {
      this.clientmaterial = []
    })
  },
  watch: {
    'yfkForm.dedutel': function(newVal) {
      if (newVal !== null && newVal !== '' && newVal !== undefined) {
        if (this.yfksounds === 60) {
          this.yfkisDisabledCode = false
        }
      } else {
        this.yfkisDisabledCode = true
      }
    }
  },
  methods: {
    changeradio() {
      // 不包含厂部色板
      if (this.editForm.source.indexOf(0) === -1) {
        this.editForm.sids = []
      }
    },
    getCbList(query = '') {
      this.cbList = []
      this.cbLoading = true
      getColorBoardList({
        page: 1,
        limit: 9999,
        content: query,
        brandid: this.editForm.bid,
        seriesid: ''
      }).then(response => {
        this.cbList = response.data || []
        this.cbLoading = false
      }).catch(() => {
        this.cbList = []
        this.cbLoading = false
      })
    },
    orderChangConfirm(ocid) {
      this.orderChangeOperForm.ocid = ocid
      this.orderChangeOperVisible = true
    },
    timeFormTrans(row) {
      this.timeVisible = true
      this.cmid = row.cmid
    },
    ClientReceive(n) {
      this.$refs['timeForm'].validate((valid) => {
        if (valid) {
          const data = {
            cmid: this.cmid,
            userid: this.user.userid,
            time: this.timeForm.returnHairTime,
            n: n
          }
          upReceiveTime(data).then(response => {
            this.$message({
              message: '确认完成',
              type: 'success'
            })
            this.getClientocm()
            this.timeVisible = false
          })
        }
      })
    },
    daleteOmc(row) {
      this.$confirm('此操作将删除该客供物料, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          cmid: row.cmid
        }
        deleteClientOmc(data).then(response => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getClientocm()
        })
      }).catch(() => {})
    },
    addOcm() {
      this.addOcmVisible = true
      this.ocmTitle = '填写物料信息'
      this.addOcmForm.orderid = this.orderid
      this.addOcmForm.cmname = ''
      this.addOcmForm.cmtype = '0'
      this.addOcmForm.explain = ''
    },
    ClientOcm() {
      this.$refs['addOcmForm'].validate((valid) => {
        if (valid) {
          const data = {
            orderid: this.addOcmForm.orderid,
            cmname: this.addOcmForm.cmname,
            cmtype: this.addOcmForm.cmtype,
            explain: this.addOcmForm.explain
          }
          addClientOcm(data).then(response => {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.getClientocm()
            this.addOcmVisible = false
          })
        }
      })
    },
    shipments(row) {
      this.ocmTitle = '填写物流信息'
      this.ocmForm.cmid = row.cmid
      this.ocmForm.personid = this.user.userid
      this.ocmForm.transpnum = ''
      this.ocmForm.transpName = ''
      this.ocmForm.hairTime = ''
      this.ocmVisible = true
    },
    ocmTrans() {
      this.$refs['ocmForm'].validate((valid) => {
        if (valid) {
          const data = {
            cmid: this.ocmForm.cmid,
            personid: this.ocmForm.personid,
            transpnum: this.ocmForm.transpnum,
            transpName: this.ocmForm.transpName,
            hairTime: this.ocmForm.hairTime
          }
          upClientOcm(data).then(response => {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getClientocm()
            this.ocmVisible = false
          })
        }
      })
    },
    getClientocm() {
      const data = {
        orderid: this.orderid
      }
      selectClientOcm(data).then(response => {
        this.ocms = response.data
      })
    },
    // 张金阳end
    subOrderChangeOperForm(n) {
      if (!this.orderChangeOperloading) {
        if (n === 0) {
          this.orderChangeOperRules.remark[0].required = true
        } else {
          this.orderChangeOperRules.remark[0].required = false
        }
        this.$refs[`orderChangeOperForm`].validate((valid) => {
          if (valid) {
            this.orderChangeOperloading = true
            const data = {
              userid: this.user.userid,
              role: 0,
              ocid: this.orderChangeOperForm.ocid,
              type: n,
              mark: 5,
              remark: this.orderChangeOperForm.remark
            }
            operOrderChange(data).then(response => {
              this.$message({
                message: '更改单操作成功',
                type: 'success'
              })
              this.orderChangeOperloading = false
              this.orderChangeOperVisible = false
              this.viewOrderChange({ ocid: this.orderChangeOperForm.ocid })
              this.openChangeList()
            }).catch(() => {
              this.orderChangeOperloading = false
            })
          } else {
            return false
          }
        })
      }
    },
    addOrderChangeRemark() {
      this.dynamicForm.content = ''
      this.dynamicForm.files = []
      this.dynamicForm.imgids = []
      this.dynamicForm.oldFiles = []
      this.dynamicForm.oldImages = []
      this.dynamicForm.title = '添加更改单备注'
      this.dynamicForm.dynamicId = 0
      this.dynamicForm.key = new Date().getTime().toString()
      this.orderchangeRemarkVisible = true
    },
    SubOrderChangeRemark(formName) {
      if (!this.dynamicloading) {
        this.dynamicloading = true
        const data = {
          userid: this.user.userid,
          ocid: this.editocid,
          content: this.dynamicForm.content,
          fileStr: this.dynamicForm.files.join(','),
          imgStr: this.dynamicForm.imgids.join(','),
          type: 0,
          ocrid: this.dynamicForm.dynamicId
        }
        addOrderChangeRemark(data).then(response => {
          this.$message({
            message: '更改单备注添加成功',
            type: 'success'
          })
          this.dynamicloading = false
          this.orderchangeRemarkVisible = false
          this.viewOrderChange({ ocid: this.editocid })
        }).catch(() => {
          this.dynamicloading = false
        })
      } else {
        return false
      }
    },
    subOrderChangeEdit() {
      this.$refs['editOrderChangeForm'].validate((valid) => {
        if (valid && !this.editOrderChangeLoading) {
          this.editOrderChangeLoading = true
          const data = {
            userid: this.user.userid,
            role: 0,
            ocid: this.editOrderChangeForm.ocid,
            orderid: this.editOrderChangeForm.orderid,
            type: this.editOrderChangeForm.type,
            content: this.editOrderChangeForm.content,
            remark: this.editOrderChangeForm.remark,
            imgids: this.editOrderChangeForm.imgids.join(','),
            files: this.editOrderChangeForm.files.join(',')
          }
          editOrderChange(data).then(response => {
            this.$message({
              message: '更改单提交成功',
              type: 'success'
            })
            this.editOrderChangeVisible = false
            this.editOrderChangeLoading = false
            this.openChangeList()
            if (this.viewOrderChangeVisible) {
              this.viewOrderChange({ ocid: this.editOrderChangeForm.ocid })
            }
          }).catch(() => {
            this.editOrderChangeLoading = false
          })
        } else {
          return false
        }
      })
    },
    editOrderChange(row) {
      this.editOrderChangeForm.remark = ''
      this.editOrderChangeForm.imgids = []
      this.editOrderChangeForm.files = []
      if (row !== null) {
        this.editOrderChangeTitle = '编辑更改单'
        this.editOrderChangeForm.ocid = row.ocid
        this.editOrderChangeForm.orderid = row.orderid
        this.editOrderChangeForm.content = row.content
        this.editOrderChangeForm.type = row.type
      } else {
        this.editOrderChangeTitle = '添加更改单'
        this.editOrderChangeForm.ocid = 0
        this.editOrderChangeForm.orderid = this.orderid
        this.editOrderChangeForm.type = 0
        this.editOrderChangeForm.content = ''
      }
      this.editOrderChangeVisible = true
    },
    delOrderChange(ocid) {
      this.$confirm('删除此更改单申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.orderChangeLoading = true
        delOrderChange({ ocid: ocid }).then(response => {
          this.orderChangeLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.openChangeList()
        }).catch(() => {
          this.orderChangeLoading = false
        })
      }).catch(() => {})
    },
    viewOrderChange(row) {
      if (!this.viewOrderChangeVisible) {
        this.viewOrderChangeTitle = `更改单 ${row.num} 详情`
        this.viewOrderChangeVisible = true
      }
      this.viewOrderChangeLoading = true
      this.editocid = row.ocid
      getOrderChangeDetail({ ocid: row.ocid, role: 0 }).then(response => {
        this.viewOrderChangeLoading = false
        this.viewOrderChangeData = response.data
      }).catch(() => {
        this.viewOrderChangeLoading = false
      })
    },
    openChangeList() {
      if (!this.orderChangeVisible) {
        this.orderChangeVisible = true
      }
      this.orderChangeLoading = true
      getOrderChangeListByOrderid({ orderid: this.orderid, role: 0 }).then(response => {
        this.orderChangeData = response.data
        this.orderChangeCount = this.orderChangeData.length
        this.orderChangeLoading = false
      }).catch(() => {
        this.orderChangeLoading = false
      })
    },
    changeType(val) {
      if (val === 3) {
        this.editRules.oldorderid[0].required = false
        this.editRules.beforenum[0].required = false
        this.editRules.beforeyear[0].required = false
      } else {
        this.editRules.oldorderid[0].required = true
        this.editRules.beforenum[0].required = true
        this.editRules.beforeyear[0].required = true
      }
    },
    downFile(fileid) {
      getFileInfo({ fileid: fileid }).then(response => {
        /* this.$message({
          message: '已下载 ' + response.data.dName + '.' + response.data.dType,
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    getOrder() {
      this.loading = true
      getDealerOrderDetail({ orderid: this.orderid, userid: this.user.userid }).then(response => {
        this.isokyfk = response.data.isokyfk
        this.orderInfo = response.data.orderDetail
        this.afterInfo = response.data.afterInfo
        this.offerInfo = response.data.quoteInfo
        if (this.offerInfo !== null && this.offerInfo !== undefined) {
          this.UpperAmount = digitUppercase(this.offerInfo.amount)
        }
        if (response.data.orderChangeCount !== null && response.data.orderChangeCount !== undefined) {
          this.orderChangeCount = response.data.orderChangeCount
        } else {
          this.orderChangeCount = 0
        }
        this.splitInfo = response.data.splitInfo
        this.roleInfo = response.data.roleInfo
        this.swatchs = response.data.swatchs || []
        let orderTitle = this.orderInfo.ordernum
        if (this.orderInfo.bid === 3) {
          if (this.orderInfo.ordernum !== null && this.orderInfo.ordernum !== '' && this.orderInfo.ordernum !== undefined) {
            orderTitle = this.orderInfo.ordernum
          }
        } else {
          if (this.orderInfo.produnum !== null && this.orderInfo.produnum !== '' && this.orderInfo.produnum !== undefined) {
            orderTitle = this.orderInfo.produnum
          }
        }
        const pageTitle = `订单详情 ${orderTitle}`
        document.title = pageTitle
        const route = Object.assign({}, this.tempRoute, { title: pageTitle })
        this.$store.dispatch('tagsView/updateVisitedView', route)
        this.loading = false
        this.isAfterinfo = false
        this.isOfferInfo = false
        this.getTrack()
      }).catch(() => {
        this.loading = false
      })
    },
    getTrack() {
      this.trackLoading = true
      getOrderTrack({ orderid: this.orderid }).then(response => {
        let arr = []
        for (const data of response.data) {
          if (data.time !== '' || data.username !== '') {
            if (data.name === '工厂分派' || data.name === '工厂接单' || data.name === '订单排产') {
              data.remark = ''
              data.position = ''
              data.username = ''
            }
            arr.push(data)
          }
        }
        // if (arr.length < response.data.length) {
        //   arr[0].remark = ''
        // }
        this.trackActivities = arr
        this.getDynamic()
      }).catch(() => {
        this.trackLoading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getDynamic()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getDynamic()
    },
    getDynamic() {
      this.trackLoading = true
      const data = {
        orderid: this.orderid,
        page: this.currentPage,
        limit: this.pageSize,
        rank: this.user.rank
      }
      getOrderDynamic(data).then(response => {
        this.orderDynamic = response.data
        this.total = response.total
        this.trackLoading = false
      }).catch(() => {
        this.trackLoading = false
      })
    },
    deleteDynamic(dynamic) {
      this.$confirm('您确定要删除这条动态吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        this.trackLoading = true
        deleteOrderDynamic({ dynamicid: dynamic.dynamic_id }).then(response => {
          this.$message({
            message: '订单动态删除成功',
            type: 'success'
          })
          this.getDynamic()
        }).catch(() => {
          this.trackLoading = false
        })
      }).catch(() => {
        this.trackLoading = false
      })
    },
    addDynamic(dynamic) {
      this.dynamicForm.content = ''
      this.dynamicForm.files = []
      this.dynamicForm.imgids = []
      this.dynamicForm.oldFiles = []
      this.dynamicForm.oldImages = []
      if (dynamic === null) {
        this.dynamicForm.title = '添加订单动态'
        this.dynamicForm.dynamicId = 0
      } else {
        this.dynamicForm.dynamicId = dynamic.dynamic_id
        this.dynamicForm.title = '修改订单动态'
        this.dynamicForm.content = dynamic.content
        for (const item of dynamic.dynamicImgs) {
          const image = {
            id: item.imgid,
            url: item.img_path
          }
          this.dynamicForm.oldImages.push(image)
        }
        for (const item of dynamic.fileList) {
          const fileName = `${item.file_name}.${item.file_type}`
          const file = {
            id: item.fileid,
            name: fileName
          }
          this.dynamicForm.oldFiles.push(file)
        }
      }
      this.dynamicForm.key = new Date().getTime().toString()
      this.dynamicVisible = true
    },
    SubDynamic(formName) {
      if (!this.dynamicloading) {
        this.dynamicloading = true
        const data = {
          userid: this.user.userid,
          orderid: this.orderid,
          content: this.dynamicForm.content,
          fileStr: this.dynamicForm.files.join(','),
          imgStr: this.dynamicForm.imgids.join(','),
          type: 0,
          dynamicId: this.dynamicForm.dynamicId
        }
        addOrderDynamic(data).then(response => {
          this.$message({
            message: '订单动态添加成功',
            type: 'success'
          })
          this.dynamicloading = false
          this.dynamicVisible = false
          this.getDynamic()
        }).catch(() => {
          this.dynamicloading = false
        })
      } else {
        return false
      }
    },
    getMaterialDetail() {
      this.materialTableData = []
      if (this.orderInfo.bid === 3) {
        this.materialTitle = this.orderInfo.ordernum + ' 拆单详情'
      } else {
        if (this.orderInfo.produnum !== null && this.orderInfo.produnum !== '' && this.orderInfo.produnum !== undefined) {
          this.materialTitle = this.orderInfo.produnum + ' 拆单详情'
        } else {
          this.materialTitle = this.orderInfo.ordernum + ' 拆单详情'
        }
      }
      this.materialVisible = true
      this.materialloading = true
      getErpOrderMaterialDetail({ orderid: this.orderid }).then(response => {
        this.materialloading = false
        this.materialTableData = response.data
      }).catch(() => {
        this.materialloading = false
      })
    },
    closeMaterial() {
      this.materialTableData = []
      this.materialVisible = false
    },
    viewAfterDetail() {
      if (!this.isAfterinfo) {
        if (this.orderInfo.produnum !== null && this.orderInfo.produnum !== '' && this.orderInfo.produnum !== undefined) {
          this.afterTitle = this.orderInfo.produnum + ' 售后处理详情'
        } else {
          this.afterTitle = this.orderInfo.ordernum + ' 售后处理详情'
        }
        this.fullscreenAfterLoading = true
        getAfterSalePageInfo({ afterid: this.afterInfo.after_id }).then(response => {
          this.afterinfoData = response.data
          this.afterinfoData.factory = this.afterinfoData.afterSale.factory
          this.afterinfoData.deptRson = this.afterinfoData.afterSale.reasonList
          this.fullscreenAfterLoading = false
          this.isAfterinfo = true
        }).catch(() => {
          this.fullscreenAfterLoading = false
        })
      }
      this.afterIVisible = true
    },
    viewOfferDetail() {
      if (!this.isOfferInfo) {
        if (this.orderInfo.bid === 3) {
          this.offerTitle = this.orderInfo.ordernum + '报价详情'
        } else {
          if (this.orderInfo.produnum !== null && this.orderInfo.produnum !== '' && this.orderInfo.produnum !== undefined) {
            this.offerTitle = this.orderInfo.produnum + ' 报价详情'
          } else {
            this.offerTitle = this.orderInfo.ordernum + ' 报价详情'
          }
        }
        this.fullscreenOfferLoading = true
        getOrderQuoteDetail({ orderid: this.orderid }).then(response => {
          let _offerImgs = []
          for (const i of response.data.imgmap) {
            if (i.ispub === 1) {
              _offerImgs.push(i.url)
            }
          }
          this.offerImgs = _offerImgs
          this.offerOther = response.data.otherlst
          this.offerChanges = response.data.changelst
          this.offerAccountReceipt = response.data.dralst
          this.fullscreenOfferLoading = false
          this.isOfferInfo = true
        }).catch(() => {
          this.fullscreenOfferLoading = false
        })
      }
      this.offerVisible = true
    },
    ddqrBtn() {
      this.ddqrRules.content[0].required = false
      this.ddqrForm.orderid = this.orderInfo.orderid
      this.ddqrForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.address
      this.ddqrForm.content = ''
      this.ddqrForm.files = []
      this.ddqrForm.imgids = []
      this.ddqrVisible = true
    },
    turnDdqr(formName) {
      this.ddqrRules.content[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubDdqrOrder(0)
        } else {
          return false
        }
      })
    },
    subEditDdqr(formName) {
      this.ddqrRules.content[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubDdqrOrder(1)
        } else {
          return false
        }
      })
    },
    SubDdqrOrder(ispass) {
      if (!this.ddqrloading) {
        this.ddqrloading = true
        const data = {
          userid: this.user.userid,
          orderid: this.ddqrForm.orderid,
          reason: this.ddqrForm.content,
          ispass: ispass,
          fileStr: this.ddqrForm.files.join(','),
          imgStr: this.ddqrForm.imgids.join(','),
          type: 0
        }
        confirmOrder(data).then(response => {
          let msg = '订单已确认'
          if (ispass === 0) {
            msg = '订单已驳回'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.ddqrloading = false
          this.ddqrVisible = false
          this.getOrder()
        }).catch(() => {
          this.ddqrloading = false
        })
      } else {
        return false
      }
    },
    countReportTime() {
      let date = new Date()
      let now = date.getTime()
      let endDate = new Date(this.yfkReportTime.curStartTime)
      let end = endDate.getTime()
      let leftTime = end - now
      if (leftTime >= 0) {
        this.yfkReportTime.day = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        let h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
        this.yfkReportTime.hour = h < 10 ? '0' + h : h
        let m = Math.floor(leftTime / 1000 / 60 % 60)
        this.yfkReportTime.min = m < 10 ? '0' + m : m
        let s = Math.floor(leftTime / 1000 % 60)
        this.yfkReportTime.second = s < 10 ? '0' + s : s
      } else {
        this.yfkReportTime.day = 0
        this.yfkReportTime.hour = '00'
        this.yfkReportTime.min = '00'
        this.yfkReportTime.second = '00'
      }
      if (Number(this.yfkReportTime.hour) === 0 && Number(this.yfkReportTime.day) === 0 && Number(this.yfkReportTime.min) === 0 && Number(this.yfkReportTime.second) === 0) {
        return
      } else {
        setTimeout(this.countReportTime, 1000)
      }
    },
    // 申请继续拆单
    sqjxCdBtn() {
      // splitStatus: 2-已暂停
      if (this.orderInfo.splitStatus != 2) return
      this.sqjxSplitForm = {
        orderid: this.orderInfo.orderid,
        ordername: this.orderInfo.ordernum + ' / ' + this.orderInfo.address,
        content: '',
        imgids: [],
        files: []
      }
      this.sqjxSplitVisible = true
    },
    // 申请继续拆单
    subSplitSqjx(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.sqjxSplitLoading) {
            this.sqjxSplitLoading = true
            const data = {
              userid: this.user.userid,
              type: 0,
              orderid: this.sqjxSplitForm.orderid,
              content: this.sqjxSplitForm.content,
              fileStr: this.sqjxSplitForm.files.join(','),
              imgStr: this.sqjxSplitForm.imgids.join(','),
              ctype: 102, // 102-申请继续拆单
            }
            addOrderDynamic(data).then(response => {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.sqjxSplitLoading = false
              this.sqjxSplitVisible = false
              this.getOrder()
            }).catch(() => {
              this.sqjxSplitLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    yfkBtn() {
      this.yfkRules.remark[0].required = false
      this.yfkisDisabledCode = true
      this.yfkForm.orderid = this.orderInfo.orderid
      this.yfkForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.produnum + ' / ' + this.orderInfo.address
      this.yfkForm.content = ''
      this.yfkofferinfo = []
      this.yfkForm.money = null
      this.yfkForm.accid = null
      this.yfkForm.dedutel = ''
      this.yfkForm.msg_id = ''
      this.yfkForm.code = ''
      this.yfkForm.deposit = 0
      this.yfkForm.accamount = 0
      this.yfkForm.key = new Date().getTime()
      this.yfkVisible = true
      this.yfkofferinfoLoading = true
      getDealerTelList({ delid: this.orderInfo.delid, page: 1, limit: 9999999 }).then(response => {
        this.yfkDealerTelList = response.data
      }).catch(() => {})
      getErpOrderOfferDetail({ orderid: this.orderInfo.orderid }).then(response => {
        this.yfkofferinfo = response.data
        if (this.yfkofferinfo.reportEndtime !== null && this.yfkofferinfo.reportEndtime !== '' && this.yfkofferinfo.reportEndtime !== undefined) {
          this.yfkReportTime.curStartTime = this.yfkofferinfo.reportEndtime
          this.countReportTime()
        }
        this.yfkForm.deposit = this.yfkofferinfo.deposit
        // this.yfkForm.money = this.yfkForm.deposit
        this.yfkForm.accamount = this.yfkofferinfo.accamount
        this.yfkForm.accid = this.yfkofferinfo.accid
        this.yfkofferinfoLoading = false
      }).catch(() => {
        this.yfkofferinfoLoading = false
      })
    },
    yfkgetCode() {
      if (this.yfkForm.dedutel !== null && this.yfkForm.dedutel !== '' && this.yfkForm.dedutel !== undefined) {
        if (this.yfkForm.deposit > 0) {
          if (this.yfkForm.money !== null && parseFloat(this.yfkForm.money) > 0) {
            if (parseFloat(this.yfkForm.money) <= parseFloat(this.yfkForm.accamount)) {
              if (parseFloat(this.yfkForm.money) >= parseFloat(this.yfkForm.deposit)) {
                if (!this.yfkisDisabledCode) {
                  if (this.yfksounds === 60) {
                    this.yfkisCodeLoading = true
                    const arr = this.yfkForm.dedutel.split('@')
                    const data = {
                      verifyCode: '1434619f6b1b490fc7b225e6c052abd3',
                      opertype: 0,
                      userid: this.user.userid,
                      type: 0,
                      dataid: this.yfkForm.orderid,
                      amount: this.yfkForm.money,
                      phoneNum: arr[1],
                      receiver: arr[0]
                    }
                    getDebitSMSCode(data).then(response => {
                      this.yfkForm.msg_id = response.data
                      this.yfkisCodeLoading = false
                      this.yfkisDisabledCode = true
                      this.yfkcodeTimer = setInterval(this.yfkcountdown, 1000)
                    }).catch(() => {
                      this.yfkisCodeLoading = false
                    })
                  } else {
                    this.yfkisDisabledCode = true
                  }
                }
              } else {
                this.$message.error('扣款金额至少为 ' + this.yfkForm.deposit + ' 元')
              }
            } else {
              this.$message.error('账户余额不足')
            }
          } else {
            this.$message.error('请输入扣款金额')
          }
        } else {
          this.$message.error('预付款为0元，无需扣款')
        }
      } else {
        this.$message.error('请选择扣款验证手机号码')
      }
    },
    yfkcountdown() {
      this.yfksounds--
      if (this.yfksounds === 0) {
        clearInterval(this.yfkcodeTimer)
        this.yfkcodeBtn = '获取验证码'
        this.yfkisDisabledCode = false
        this.yfksounds = 60
      } else {
        this.yfkcodeBtn = '重新获取 ' + this.yfksounds
      }
    },
    turnYfk(formName) {
      this.yfkRules.remark[0].required = true
      this.yfkRules.money[0].required = false
      this.yfkRules.dedutel[0].required = false
      this.yfkRules.code[0].required = false
      this.yfkRules.imgids[0].required = false
      this.yfkRules.receipttime[0].required = false
      this.yfkRules.aid[0].required = false
      this.yfkRules.card[0].required = false

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.yfkloading) {
            this.yfkloading = true
            const data = {
              userid: this.user.userid,
              orderid: this.yfkForm.orderid,
              reason: this.yfkForm.remark,
              type: 0
            }
            insteadSubsistDown(data).then(response => {
              this.$message({
                message: '订单已驳回',
                type: 'success'
              })
              this.yfkloading = false
              this.yfkVisible = false
              this.yfksounds = 60
              if (this.yfkcodeTimer !== null && this.yfkcodeTimer !== '' && this.yfkcodeTimer !== undefined) {
                clearInterval(this.yfkcodeTimer)
                this.yfkcodeTimer = ''
                this.yfkcodeBtn = '获取验证码'
                this.yfkisDisabledCode = true
              }
              this.getOrder()
            }).catch(() => {
              this.yfkloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    subEditYfkTg(formName) {
      if (!this.yfkloading) {
        this.yfkloading = true
        const data = {
          userid: this.user.userid,
          orderid: this.orderid,
          pay: 0,
          remark: this.yfkForm.remark,
          type: 0
        }
        insteadSubsist(data).then(response => {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.yfkVisible = false
          this.yfkloading = false
          this.getOrder()
        }).catch(() => {
          this.yfkloading = false
        })
      } else {
        return false
      }
    },
    subEditYfk(formName) {
      this.yfkRules.remark[0].required = false
      this.yfkRules.money[0].required = true
      this.yfkRules.dedutel[0].required = true
      this.yfkRules.code[0].required = true
      this.yfkRules.imgids[0].required = true
      this.yfkRules.receipttime[0].required = true
      this.yfkRules.aid[0].required = true
      this.yfkRules.card[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.yfkloading) {
            if (parseFloat(this.yfkForm.money) > 0) {
              this.yfkloading = true
              const data = {
                userid: this.user.userid,
                role: 0,
                applyid: 0,
                dealerid: this.user.delid,
                date: this.yfkForm.receipttime,
                money: this.yfkForm.money,
                accountid: this.yfkForm.aid,
                card: this.yfkForm.card,
                nature: '预付款',
                imgStr: this.yfkForm.imgids.join(','),
                remark: this.yfkForm.remark,
                orderid: this.orderid
              }
              addOrEditCollectApplyConfirm(data).then(response => {
                this.$message({
                  message: '提交成功',
                  type: 'success'
                })
                this.yfkVisible = false
                this.yfkloading = false
                this.getOrder()
              }).catch(() => {
                this.yfkloading = false
              })
            } else {
              this.$message.error('打款金额不可小于0')
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    edit() {
      if (!this.isHaveBrand) {
        getErpDealerBrandList({ delid: this.user.delid }).then(response => {
          this.brandInfo = response.data
          this.isHaveBrand = true
        }).catch(() => {
          this.brandInfo = []
          this.isHaveBrand = false
        })
      }
      this.editForm.delid = this.user.delid
      this.editForm.type = this.orderInfo.type
      this.editForm.oldorderid = this.orderInfo.oldorderid
      this.editForm.beforenum = this.orderInfo.beforenum
      this.editForm.beforeyear = this.orderInfo.beforeyear
      if (this.editForm.oldorderid !== null && this.editForm.oldorderid !== '' && this.editForm.oldorderid !== undefined) {
        this.isManual = false
      } else {
        this.isManual = true
      }
      if (this.editForm.type === 3) {
        this.editRules.oldorderid[0].required = false
        this.editRules.beforenum[0].required = false
        this.editRules.beforeyear[0].required = false
      } else {
        this.editRules.oldorderid[0].required = true
        this.editRules.beforenum[0].required = true
        this.editRules.beforeyear[0].required = true
      }
      this.editForm.custname = this.orderInfo.custname
      this.editForm.custtel = this.orderInfo.custtel
      this.editForm.address = this.orderInfo.address
      this.editForm.exptime = this.orderInfo.exptime
      this.editForm.designer = this.orderInfo.designer
      this.editForm.designerTel = this.orderInfo.designerTel
      this.editForm.estimated = this.orderInfo.estimated
      this.editForm.bid = this.orderInfo.bid
      let source = []
      if (this.orderInfo.source.indexOf('厂部标准色板') !== -1) {
        source.push(0)
        this.editForm.sids = this.swatchs.map(r => r.board_id)
      }
      if (this.orderInfo.source.indexOf('客户提供色板') !== -1) {
        source.push(1)
      }
      if (this.orderInfo.source.indexOf('厂部定制色板') !== -1) {
        source.push(2)
      }
      this.editForm.source = source
      if (!this.editForm.sids) this.editForm.sids = []
      // this.editForm.source = this.orderInfo.source
      this.orderLoad = new Date().getTime()
      this.editVisible = true

      this.getCbList()
    },
    setOrder(data) {
      this.editForm.custname = data.custname
      this.editForm.custtel = data.custtel
      this.editForm.address = data.address
      this.editForm.beforenum = data.produnum
      this.editForm.beforeyear = data.time.substring(0, 4)
      this.editForm.bid = data.bid
      this.editForm.designer = data.designer
      this.editForm.designerTel = data.designerTel
      if (data.source !== null && data.source !== undefined && data.source !== '') {
        this.editForm.source = data.source.split(',')
      } else {
        this.editForm.source = []
      }
    },
    openManual() {
      this.editForm.oldorderid = ''
      this.editForm.beforenum = ''
      this.editForm.beforeyear = ''
      this.isManual = true
    },
    subEditOrder(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              orderid: this.orderInfo.orderid,
              userid: this.user.userid,
              delid: this.editForm.delid,
              type: this.editForm.type,
              oldorderid: this.editForm.oldorderid,
              beforenum: this.editForm.beforenum,
              beforeyear: this.editForm.beforeyear,
              custname: this.editForm.custname,
              custtel: this.editForm.custtel,
              address: this.editForm.address,
              exptime: this.editForm.exptime,
              designer: this.editForm.designer,
              designerTel: this.editForm.designerTel,
              estimated: this.editForm.estimated,
              bid: this.editForm.bid,
              source: this.editForm.source.join(','),
              sids: this.editForm.sids.join(',')
            }
            DealerOrderEdit(data).then(response => {
              this.editloading = false
              this.$message({
                message: '订单提交成功',
                type: 'success'
              })
              this.editVisible = false
              this.getOrder()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },

    exportExcelMaterial() {
      if (this.multipleSelection.length > 0) {
        if (!this.exportMaterialLoading) {
          this.exportMaterialLoading = true
          let packids = []
          for (let p of this.multipleSelection) {
            packids.push(p.packid)
          }
          const data = {
            orderid: this.packForm.orderid,
            packids: packids.join(',')
          }
          exportShippingList(data).then(response => {
            this.exportMaterialLoading = false
            const _this = this
            let xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.file_url, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                let blob = this.response
                let a = document.createElement('a')
                a.download = response.data.dName
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a',
                      { attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }}, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                  }
                }).then(action => {
                })
              }
            }
            xhr.send()
          }).catch(() => {
            this.exportMaterialLoading = false
          })
        }
      } else {
        this.$message.error('至少选择一个包装进行导出')
      }
    },
    openDetails(row) {
      if (row.bid === 3) {
        this.packTitle = row.ordernum + ' 打包详细'
      } else {
        this.packTitle = row.produnum + ' 打包详细'
      }
      this.packForm.orderid = row.orderid
      this.packForm.packnum = ''
      this.packForm.xuhao = ''
      this.packVisible = true
      this.searchPack()
    },
    searchPack() {
      this.packTableData = []
      this.packloading = true
      const data = {
        orderid: this.packForm.orderid,
        packnum: this.packForm.packnum,
        xuhao: this.packForm.xuhao,
        imark: 1,
        isall: 1,
        iskc: 1
      }
      getErpOrderPackList(data).then(response => {
        this.packTableData = response.data
        this.packloading = false
      }).catch(() => {
        this.packloading = false
      })
    },
    openPackDetails(row) {
      this.$refs.packTable.toggleRowExpansion(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

  }
}
</script>

<style lang="scss" scoped>
.orderHomepage-container{
  .mt{
    margin-top: 20px;
  }
  .order-info{
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    .tit{
      color:#99a9bf;
    }
    .price{
      color:#F56C6C;
      font-weight: 500;
    }
    .mf{
      margin-left: 30px
    }
    .link{
      color:#409EFF;
      cursor: pointer;
      font-weight: 500;
      &:hover{
        opacity: 0.8;
      }
    }
    .file-item{
      cursor: pointer;
      background: #f6f7fa;
      color:#909399;
      padding: 10px 10px 10px 44px;
      position: relative;
      width: 100%;
      i{
        position: absolute;
        font-size: 30px;
        left: 10px;
        top:10px;
      }
      .file-name{
        width: 100%;
        height: 30px;
        font-size: 12px;
        line-height: 15px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      &:hover{
        color:#409EFF;
      }
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
  .info-ellipsis{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .order-track{
    overflow-x: auto;
    overflow-y: hidden;
    .order-track-info{
      width: 2240px;
      position: relative;
      .el-steps{
        .el-step{
          flex-basis: 160px!important;
        }
      }
    }
  }
  .order-dynamic-not{
    width: 100%;
    height: 100px;
    line-height: 100px;
    font-size: 12px;
    color:#999;
    text-align: center;
  }
  .order-dynamic-item{
    width: 100%;
    position: relative;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f5f7fa;
    padding-left: 60px;
    padding-right: 60px;
    min-height: 60px;
    .photo{
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
      top:0;
    }
    .info{
      position: relative;
      padding-right: 40px;
      width: 100%;
      .username{
        margin-bottom: 6px;
        span{
          &:first-child{
            font-size: 14px;
            font-weight: 500;
            margin-right: 6px;
          }
        }
      }
      .time{
        font-size: 12px;
        color:#999;
        margin-bottom: 6px;
        position: absolute;
        right: 0;
        top:4px;
      }
      .content{
        margin-bottom: 6px;
      }
      .files{
        position: relative;
        width: 100%;
        .file-item{
          cursor: pointer;
          float: left;
          background: #f6f7fa;
          color:#909399;
          padding: 10px 10px 10px 44px;
          position: relative;
          width: 200px;
          margin-right: 10px;
          margin-bottom: 6px;
          i{
            position: absolute;
            font-size: 30px;
            left: 10px;
            top:10px;
          }
          .file-name{
            width: 100%;
            height: 30px;
            font-size: 12px;
            line-height: 15px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          &:hover{
            color:#409EFF;
          }
        }
        &:after,&:before{
          content: '';
          display: block;
          clear: both;
        }
      }
      .imgs{
        .dynamic-img{
          width:60px;
          height: 60px;
          margin-right: 10px;
          border:1px dashed #f5f7fa;
        }
      }
    }
    &:last-child{
      border-bottom: 0px;
    }
  }

  .menu-list{
    width: 100%;
    position: relative;
    .menu-item{
      float: left;
      width: 80px;
      margin: 4px 10px 10px 0;
      padding:10px;
      position: relative;
      border-radius: 2px;
      cursor: pointer;
      .menu-item-img{
        text-align: center;
        width: 100%;
        svg{
          width: 50px!important;
          height: 50px!important;
        }
      }
      .menu-item-name{
        width: 100%;
        text-align: center;
        padding-top: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        font-weight: bold;
      }
      .el-badge__content{
        top: 20px!important;
        right: 30px!important;
      }
      &:hover{
        background: #f5f7fa;
      }
    }
    &:after{
      content: ' ';
      clear: both;
      display: table;
    }
  }
}
</style>
